// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/bg-drawer-header.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-size: 18px;
}
body {
  background-color: rgb(245,245,245);
  margin: 0 !important;
  color: rgb(117, 117, 117);
  font-family: Roboto, sans-serif;
}
article {
  clear: both;
}

a:link,
a:visited {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.54);
}

a.a-block {
  display: block;
  width: 100%;
}

p,h1,h2,h4 {
  color: rgb(117, 117, 117);
}
h2 {
  font-weight: 500;
  font-size: 1.5rem;
}
h3 {
  font-weight: 500;
  font-size: 1.17rem;
  margin-bottom: 6px;
}
h4 {
  font-weight: 600;
  font-size: .8rem;
  margin: 6px 0 4px 0;
  padding: 0;
}
p {
  margin: 4px 0;
  padding:0;
  line-height: 1.2rem;
  font-size: .8rem;
}

p a:link,
p a:visited,
p a:active  {
  color: rgb(35, 151, 190);
}

p a:hover  {
  text-decoration: underline;
  color: rgb(35, 151, 190);
}

p.subHeading {
  color: rgba(117, 117, 117 ,0.5);
  margin-bottom: 4px;
  display: block;
  width: 100%;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  color: rgb(117, 117, 117);
}

ul li {
  margin: 6px 0;
  padding: 0;
}

.header-wrapper {}
.cent-layout {}
.cent-main {
  padding-top: 64px !important;
}

.cent-form {}

.cent-form h2 {
  font-size: 1.1rem;
  font-weight: 400;
  margin: 16px 0 0 0;
  display: block;
  width: 100%;
}
.cent-form-element-number {
  text-align: right;
}

/* Legacy support */
.centric-content {
  text-align: center;
  width: 70%;
  margin: 0 auto;
  padding-top: 64px !important;
}
.centric-footer {
  background: black;
  color: white;
  padding: 40px 0;
  bottom: 0;
  width: 100%;
  text-align: center;
}
.centric-footer a {
  color: white;
  text-decoration: none;
}
#execptionMessage {
  background-color: #FFF;
  color: rgb(117, 117, 117);
  width: 100%;
  padding: 16px;
}
#execptionMessage h2 {
  margin: 8px;
}
/* Legacy support end */

.cent-drawer {
}

.cent-footer {
  background: black;
  color: white;
  padding: 20px 0;
  width: 100%;
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: .9rem;
  font-weight: 300;
  position: absolute;
}

.cent-footer .copyright {
  color: #BCC0C0;
  font-size: .8rem;
  margin: 8px 0 0 0;
  text-align: center;
}

.cent-footer .copyright a {
  color: #BCC0C0;
  text-decoration: none;
}

.cent-footer .copyright a:hover {
  color: #FFF;
}

.cent-footer-links li {
  display: inline-block;
  margin: 8px 16px;
}

.cent-footer-links a {
  color: #BCC0C0;
  text-decoration: none;
}

.cent-footer-links a:hover {
  color: #FFF;
}


ul.cent-list-plain.category-tree ul {
  padding-left: 2em;
}

.cent-list-plain li {
  margin: 4px 0;
  padding: 0;
  line-height: 1.2rem;
  font-size: .8rem;
}

.cent-list-plain li em {
  font-weight: 600;
  width: 33%;
  display: inline-block;
  font-style: normal;
}

.cent-list-plain a:link,
.cent-list-plain a:visited,
.cent-list-plain a:active  {
  color: rgb(35, 151, 190);
}

.cent-list-plain a:hover  {
  text-decoration: underline;
  color: rgb(35, 151, 190);
}


.cent-list-item {
  padding: 8px;
  height: 40px;
}

.cent-list-item-text {
  display: block;
}

.cent-list-item-avatar {
  float: left;
  margin: 0 16px 0 0;
}

.cent-checkbox-wrapper {
  margin: 16px 0 0 0 ;
}

.cent-checkbox-hint {
  color: rgba(117, 117, 117 ,0.5);
  font-size: 12px;
  line-height: 2;
  margin-bottom: 4px;
}

.cent-radio-button-group {
  padding: 1em;
}

.cent-radio-button-group > div {
  margin-top: 0.5em;
}

.avatar{
  background-color: rgb(35, 151, 190);
}
.avatar-required {
  background-color: rgb(183, 28, 28);
}
.avatar-toDo {
  background-color: rgb(255, 171, 0);
}
.avatar-toDo-required {
  background-color: rgb(183, 28, 28);
}
.avatar-inProgress {
  background-color: rgb(255, 215, 64);
}
.avatar-inProgress-required {
  background-color: rgb(255, 215, 64);
}
.avatar-completed {
  background-color: rgb(76, 175, 80);
}
.avatar-disabled {
  background-color: rgb(189, 189, 189);
}


.primaryText {
  font-weight: 500;
  display: block;
}
.secondaryText {
  display: block;
  line-height: 1.3em!important;
  margin-top: 2px!important;
}
.secondaryInfo {
  height: 40px;
  margin-top: 8px!important;
}

#centIdentifier {
  display: block;
  padding: 16px;
  background: #eef3f4 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right top;
  margin: 0 0 16px 0!important;
}

.cent-username a {
  color: #FFF !important;
  display: block;
  clear: none;
  margin: 16px 0;
}

.cent-progressLabel {
  clear: none;
  float: left;
  padding: 16px;
  margin: 8px 8px 16px 16px;
}

.cent-progressLabel-text {
 display: inline;
}

.progressBar {
  margin: 0 0 4px 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  border: none;
  height: 12px;
  line-height: 12px;
  background-color: rgb(239, 239, 239);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.progressBar .segment {
  display: inline;
  flex-grow: 1;
  border: none;
  background-color: #FFF;
  height: 12px;
  margin: 0;
  line-height: 10px;
}

.progressBar > :first-child,
.progressBar > :first-child a {
  -webkit-border-radius: 5px 0 0 5px;
  -moz-border-radius: 5px 0 0 5px;
  border-radius: 5px 0 0 5px;
}

.progressBar > :last-child,
.progressBar > :last-child a {
  -webkit-border-radius: 0 5px 5px 0;
  -moz-border-radius: 0 5px 5px 0;
  border-radius: 0 5px 5px 0;
}

.progressBar > :only-child,
.progressBar > :only-child a {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.progressBar .segment a {
  display: block;
  height: 12px;
  width: 100%;
}
.progressBar .segment a:hover {
  background-color: #FFF;
}
.progressBar .segment.canceled {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.canceled a:hover {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.waiting {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.waiting a:hover {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.enrolled {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.enrolled a:hover {
  background-color: rgb(239, 239, 239);
}

.progressBar .segment.completed {
  background-color: rgb(35, 151, 190);
}
.progressBar .segment.completed a:hover {
  background-color: rgb(57, 170, 211);
}
.progressBar .segment.partial {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.partial a:hover {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.none {
  background-color: rgb(239, 239, 239);
}
.progressBar .segment.none a:hover {
  background-color: rgb(239, 239, 239);
}
.progressBar.requirements .segment.partial {
  background-color: rgb(239, 239, 239);
}
.progressBar.requirements .segment.partial a:hover {
  background-color: rgb(239, 239, 239);
}
.progressBar.requirements .segment.none {
  background-color: rgb(239, 239, 239);
}
.progressBar.requirements .segment.none a:hover {
  background-color: rgb(239, 239, 239);
}

.progressBar.cancelled .segment {
  background-color: #E0E0E0;
}
.progressBar.cancelled .segment a:hover {
  background-color: #E0E0E0;
}
.progressBar.cancelled .segment.completed {
  background-color: #999;
}
.progressBar.cancelled .segment.completed a:hover {
  background-color: #AAA;
}

.progressBar .segment.success {
  background-color: #4CAE50;
}
.progressBar .segment.success a:hover {
  background-color: #4cb54f;
}
.progressBar.success .segment {
  background-color: rgb(239, 239, 239);
}
.progressBar.success .segment a:hover {
  background-color: rgb(239, 239, 239);
}

.secondaryInfo .progressBar {
  max-width: 50%;
}

.progressBar-label {
  margin: 8px 0;
}
.spot {
  display: inline-block;
  background-color: rgba(117, 117, 117 ,0.7);
  border-radius: 50%;
  width: .7em;
  height: .7em;
  margin: 0 8px 0 8px;
}
.spot.spot-optional {
  background-color: #F9B205;
}
.spot.spot-mandatory {
  background-color: #B71B1C;
}

.flag-text {
  color: #FFF;
  background-color: rgba(117, 117, 117 ,0.7);
  border-radius: 5px;
  padding: 1px 5px;
  margin: 0 8px 0 0;
  text-transform: uppercase;
  font-size: .8em;
}

.flag-mandatory,
.flag-optional {
  color: #FFF;
  border-radius: 5px;
  padding: 1px 4px;
  margin: 0 8px 0 0;
  text-transform: uppercase;
}
.flag-mandatory {
  background-color: #B71B1C;
}
.flag-optional {
  background-color: #F9B205;
}
.flag-success {
  background-color: #4CAE50;
}

.icon-duration {
  color: #696969;
  background-color: #CCC;
  border: 1px solid #CCC;
  border-radius: 5px;
  padding: 1px 4px;
  margin: 0 8px 0 0;
  display: inline-block;
}

.icon-small {
  height: 16px!important;
  width: 16px!important;
  margin: 2px 8px 0 0!important;
  padding: 0!important;
}

.icon-small-td {
  height: 12px!important;
  width: 12px!important;
  margin: 0 0 0 8px!important;
  padding: 0!important;
}

.icon-small-li {
  height: 12px!important;
  width: 12px!important;
  margin: 0 8px 0 0!important;
  padding: 0!important;
}

.icon-micro {
  height: 12px;
  font-size: 10px;
  line-height: 11px;
}

.tbl-td-icon {
  padding: 0!important;
  text-align: center!important;
}

.tbl-td-number {
  width: 11%!important;
  text-align: right!important;
}

.tbl-td-actions {
  padding: 0!important;
  text-align: right!important;
}

.cent-container {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.cent-hero-space {
  background-color: rgb(31, 115, 146);
  width: 100%;
  color: #FFF;
}
.cent-breadcrumbs {
  font-size: .7rem;
  font-weight: 300;
  color: #FFF;
  list-style: none;
  margin: 0;
  padding: 0;
}
.cent-breadcrumbs li {
  display: inline-block;
  margin-right: 8px;
}
.cent-breadcrumbs li a {
  color: #FFF;
  text-decoration: none;
}
.cent-breadcrumbs li a:hover {
  color: #FFF;
  text-decoration: underline;
}

.cent-hero-content {
  padding: 36px;
  width: 70%;
}
.cent-hero-content h2 {
  color: #FFF;
  letter-spacing: 1px;
  margin: 16px 0 16px 0;
}
.cent-hero-content p {
  color: #FFF;
  letter-spacing: 1px;
  padding: 0 0 16px 0;
}

.cent-dialog {
 }
.cent-dialog-text {
  margin-bottom: 42px!important;
}
.cent-dialog-actions {
  position: absolute!important;
  display: block;
  margin-top: 16px;
  bottom: 8px;
  right: 8px;
  text-align: right;
}

.cent-cards {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 16px 0 16px 0;
}
.cent-cards-header {
  width: 100%;
  margin:  8px 8px 16px 8px;
}
.cent-cards-header h2{
  margin: 0;
}

.cent-card {
  color: rgb(117, 117, 117);
  margin:  8px 8px 8px 8px;
  flex-grow: 1;
  position: relative;
}
.cent-card-4 {
  width: 30%;
}
.cent-card-6 {
  width: 48%;
}
.cent-card-6 > div {
  height: 100%;
}

.cent-card-flex-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.cent-card-flex-title {
  flex-grow: 1;
}

.cent-card-8 {
  width: 66%;
}
.cent-card-12 {
  width: 100%;
}
.cent-card-micro {
  width: 30%;
  margin-bottom: 4px !important;
}
.cent-card-list {
  padding: 0!important;
}

.cent-card-list-item {
  width: 48%;
  margin-bottom: 4px !important;
}

.cent-card-header button {
  margin: 0!important;
}


.cent-flex-row {
  display: flex; /* or inline-flex */
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.cent-flex-column {
  flex-direction: column;
  justify-content: space-between;
}

.cent-col-1 {
  width: 100%;
}
.cent-col-2 {
  width: 50%;
}
.cent-col-3 {
  width:33%;
}
.cent-col-4 {
  width:34%;
}
.cent-col-8 {
  width:66%;
}
.cent-col-12 {
  width:100%;
}

.cent-zero {
  padding: 0!important;
}

.cent-card-text {
  padding-top: 0 !important;
}

.cent-card-text p {
  margin-bottom: 16px;
}

.cent-card-text h4,
.cent-card-text h5 {
  margin: 4px 0;
  padding: 0;
}
.cent-card-text h4 {
  font-size: .8rem;
  line-height: 1.2rem;
  font-weight: 600;
}
.cent-card-text h5 {
  font-size: .7rem;
  font-weight: 300;
}

.cent-card-text h4 a:link,
.cent-card-text h4 a:active,
.cent-card-text h4 a:visited {
  color: rgb(117, 117, 117);
  text-decoration: none;
}
.cent-card-text h4 a:hover {
  color: rgb(117, 117, 117);
  text-decoration: underline;
}

.cent-card-chips,
.cent-card-chips-r {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px 16px 16px!important;
}
.cent-card-chips-r {
  flex-direction: row-reverse;
}

.cent-card-chips-mid {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px!important;
}

.cent-form-chips {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 16px 0!important;
}

.cent-card-actions {
  padding: 0 16px!important;
  text-align: right;
}

.cent-card-header-buttons {
  position: absolute;
  top: 0;
  right: 0;
  text-align: right;
  margin: 16px;
}

.cent-card-header-buttons .cent-icon {
  margin-left: 16px;
}

.cent-progress-bar-circular {
  width: 180px;
  padding: 0;
  margin: 0 16px;
}

.button-raised {
  margin-bottom: 16px;
}

.buttonRaised {
  display: block;
  width: 100%;
  padding: 8px;
  font-size: 1rem;
  font-family: Roboto, sans-serif;
  color: #FFF;
  text-transform: uppercase;
  letter-spacing: .2rem;
  background-color: rgb(35, 151, 190);
  border: solid 1px rgb(35, 151, 190);
  border-radius: 4px;
}

.buttonRaised:hover {
  background-color: rgb(38, 181, 214);
}

.cent-page {
  padding: 32px;
  margin: 0 auto 0 auto;
  max-width: 1200px;
}

.cent-page-formal h3 {
  margin-top: 32px;
  margin-bottom: 8px;
}

.cent-page-formal p {
  text-align: justify;
}

.cent-content {
  display: flex; /* or inline-flex */
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  padding: 0 16px 16px 16px;
}

.cent-content h2,
.cent-content h3,
.cent-content h4 {
  padding: 0;
  margin: 0;
}
.cent-content h2 {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
}

.cent-content-white {
  background-color: #FFF;
}

.content-left {
  flex-grow: 1;
  margin-right: 16px;
  min-width: 110px;
  max-width: 200px;
  order: 0;
}
.content-main {
  flex-grow: 3;
  font-size: .8rem;
  order: 2;
}

.content-main div {
  margin: 0 0 16px 0;
}

.content-main div:first-of-type {
  margin: 0 0 4px 0;
}

.content-main div:last-of-type {
  margin: 0;
}

.content-right {
  flex-grow: 1;
  margin-left: 16px;
  order: 3;
}
.content-right > div {
  padding: 0 0 0 16px;
  position: relative;
  margin: 0 0 16px 0;
  text-align: center;
  min-width: 110px;
}
.cent-category {
  position: relative;
  padding: 16px;
  margin: 0;
  border-left: 16px solid rgb(31, 115, 146);
  display: block;
}
.cent-category-header {
  position: relative;
  padding: 0;
  margin: 0;
  font-weight: 500;
}
.cent-category-links {
  position: relative;
  padding: 0;
  margin: 8px 0 0 0;
  font-size: .89rem;
}

.cent-stat {
  position: relative;
  height: 60px;
  padding: 16px;
  margin: 0;
  border-left: 16px solid rgb(35, 151, 190);
}

.cent-stat:hover  {
  border-left: 16px solid rgb(57, 170, 211);
}
.cent-stat-count {
  padding: 0;
  margin: 0 0 8px 0;
  position: absolute;
  top: 16px;
  left: 16px;
  width: 50%;
  display: block;
  font-size: 1.5rem;
  font-weight: 300;
  color: rgb(35,151,190);
}
.cent-stat-count a:link {
  color: rgb(35, 151, 190);
}
.cent-stat-count i {
  font-size: .8rem;
  color: rgba(128, 134, 135, 0.54)
}

.cent-stat-title {
  padding: 0;
  margin: 0;
  width: 50%;
  position: absolute;
  bottom: 16px;
  left: 16px;
  text-transform: uppercase;
  font-size: .7rem;
  display: inline;
  clear: left;
}

.cent-stat-icon {
  padding: 0;
  margin: 16px 16px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  float: right;
  clear: none;
}

.badge-duration {
  color: #FFF;
  display: block;
  line-height: 1rem;
  font-size: 1rem;
  text-align: center;
  padding: 8px;
  margin: 0 auto;
  border-radius: 25px;
  background-color: rgb(117, 117, 117);
  border: 2px solid rgb(117, 117, 117);
}

.badge-cpd {
  color: #FFF;
  display: block;
  line-height: 1rem;
  font-size: 1rem;
  text-align: left;
  padding: 0;
  margin: 0 auto;
  border-radius: 25px;
  border: 2px solid rgb(35, 151, 190);
  background: rgb(35, 151, 190);
}

.badge-cpd-amount {
  display: inline-block;
  border: 2px solid #FFF;
  padding: 5px;
  margin: 0 8px 0 0;
  text-align: center;
  min-width: 16px;
  border-radius: 25px;
  background-color: #FFF;
  color: rgb(35, 151, 190);
}

.badge-score {
  color: #CBCBCB;
  display: block;
  line-height: 2rem;
  font-size: 1.3rem;
  text-align: center;
  padding: 0 16px;
  margin: 0 auto;
  border-radius: 25px;
  background-color: #FFF;
  border: 2px solid #FFF;
}
.badge-score em {
  color: rgb(117, 117, 117);
  font-size: 2rem;
  margin-right: 4px;
  font-style: normal;
}

.badge-subtitle {
  color: #CBCBCB;
  border-top: 2px solid #CBCBCB;
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: .7rem;
  text-transform: uppercase;
}

.price {
  line-height: 1.3rem;
  font-size: 1.2rem;
  color: rgb(117, 117, 117);
}

.mapMarker {
  display: block;
  position: relative;
}
.mapMarker-icon {
  position: absolute;
  top: -32px;
  left: -12px;
  width: 32px;
  height: 32px;
}

.mapMarker-title {
  position: absolute;
  top: -30px;
  left: 18px;
  width: 200px;
  font-weight: 400;
  font-size: 1.2em;
  color: #000;
}


.cent-event {
  color: rgb(117, 117, 117)!important;
  background-color: rgb(174, 233, 252)!important;
}
.cent-event-past {
  color: rgb(117, 117, 117)!important;
  background-color: rgb(174, 233, 252)!important;
}

.cent-event-attendance {
  background-color: rgb(35, 151, 190)!important;
}



.cent-schedule-segment {
  display: block;
}
.cent-schedule-segment a {
  color: #FFF;
  text-decoration: none;
  display: block;
  padding: 2px;
  background-color: rgb(35, 151, 190);
  border-radius: 5px;
}

.profile-avatar-wrapper {
  color: rgb(117, 117, 117);
  display: block;
  line-height: 30px;
  font-size: 16px;
  text-slign: center;
  font-style: italic;
  margin: 6px 0;
}

.profile-avatar {
  margin: 0 auto;
  width: 100px;
  height: 100px;
}

.divider {
  clear: both;
}

.skill-levels {
  width: 120px;
  height: 30px;
  display: flex; /* or inline-flex */
  flex-direction: row;
  justify-content:  center;
}
.skill-levels > div {
  width: 30px;
  height:15px;
  margin: auto;
  background-color: rgb(112, 219, 255);
  border: 1px solid rgb(112, 219, 255);
  border-radius: 2px;
}
.skill-levels div.active {
  background-color: rgb(35, 151, 190);
  border: 1px solid rgb(35, 151, 190);
}
.skill-levels div.trainer {
  background-color: rgb(112, 219, 255);
  border: 1px solid rgb(112, 219, 255);
}
.skill-levels div.trainer.active {
  background-color: rgb(0, 131, 143);
  border: 1px solid rgb(0, 131, 143);
}

p.version {
  padding: 0;
}

/* Smartphones (portrait) ----------- */
@media screen and (max-width : 400px) {
  .cent-cards,
  .cent-form,
  .cent-paper,
  .cent-list,
  .cent-tree {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .cent-card {
    width: 96%;
    margin: 0 auto 4px auto !important;
  }
  .cent-card-micro,
  .cent-card-list-item {
    width: 90%;
    margin: 0 0 1px 0!important;
    border-bottom: 1px solid rgb(220,220,220);
    box-shadow: 0 0 0 rgba(0,0,0,0.0), 0 0 0 rgba(0,0,0,0.0)!important;
    border-radius: 0!important;
  }
  .cent-col-4,
  .cent-col-8 {
    width:100%;
  }
  .toolbar-title span {
    font-size: 1.2rem!important;
  }
  .cent-container {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
  .cent-hero-content {
    padding: 16px;
    width: 100%;
  }

}

@media screen and (max-width: 700px) {
  .toolbar-title  {
    max-width: 50%;
    overflow: hidden;
  }
  .toolbar-title span {
    font-size: 1rem!important;
    max-width: 100%;
  }

  .cent-cards {
    margin: 0;
  }
  .cent-cards,
  .cent-form,
  .cent-paper,
  .cent-list,
  .cent-tree {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .cent-card {
    width: 96%;
    margin: 0 auto 4px auto !important;
  }
  .cent-card-6 {
    width: 90%;
  }
  .cent-card-list-item {
    width: 90%;
    margin: 0 0 1px 0!important;
    border-bottom: 1px solid rgb(220,220,220);
    box-shadow: 0 0 0 rgba(0,0,0,0.0), 0 0 0 rgba(0,0,0,0.0)!important;
    border-radius: 0!important;
  }
  .cent-card-media span:first-of-type {
    font-size: 1.1rem!important;
  }
  .secondaryInfo .progressBar {
    width: 100% !important;
    max-width: 100%;
  }
  .primaryText {
    line-height: 1rem;
  }
  .flag-optional,
  .flag-mandatory {
    font-size: .7rem;
  }
  .cent-col-2 {
    width: 100%;
  }
  .cent-card-text {
    flex-direction: column;
  }
  .content-left {
    display: flex; /* or inline-flex */
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;

  }
  .content-main {
    flex-grow: 1;
    order: 1;
  }
  .content-right {
    display: flex; /* or inline-flex */
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    margin: 16px 0 0 0;
    order: 2;
  }
  .profile-avatar-wrapper {
    float: left;
    margin: 0 16px 0 0;
  }
  .login-dialog {
    max-width: 350px !important;
  }
}

@media screen and (max-width: 890px) {
  .cent-col-4,
  .cent-col-8 {
    width:100%;
  }
  .cent-card-list-item {
    width: 90%;
    margin: 0 0 1px 0!important;
  }

}

/* iPads (portrait and landscape) ----------- */
@media only screen and (min-width : 960px) {
  .cent-cards,
  .cent-form,
  .cent-paper,
  .cent-list,
  .cent-tree {
    width: 90%;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .cent-splash {
    padding-left: 10px;
    padding-right: 10px;
  }

}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {

}

/* iPads (portrait) ----------- */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {

}

/* Desktops and laptops ----------- */
@media only screen  and (min-width : 1224px) {
  .cent-card-6 {
    width: 30%;
  }
  .cent-card-list-item {
    width: 30%;
  }
  .cent-card-micro {
    width: 24%;
  }
}

/* Large screens ----------- */
@media only screen  and (min-width : 1824px) {
  /* Styles */
}

@media print  {

  body {
    background-color: #FFF!important;
    margin: 0 !important;
    color: rgb(117, 117, 117)!important;
  }
  a {
    color: rgb(117, 117, 117)!important;
  }
  .toolbar,
  button {
    display: none!important;
  }
  .cent-main {
    padding-top: 0 !important;
    margin: 0 !important;
  }
  .cent-cards,
  .cent-form,
  .cent-paper,
  .cent-list,
  .cent-tree {
    width: 100%;
    margin: 0!important;
    border: none!important;
    -webkit-box-shadow: none!important;
    -moz-box-shadow: none!important;
    box-shadow: none!important;
  }
 .cent-card {
   border: none!important;
   -webkit-box-shadow: none!important;
   -moz-box-shadow: none!important;
   box-shadow: none!important;
 }
}

.validation-error {
    position: relative;
    bottom: 15px;
    font-size: 12px;
    line-height: 12px;
    color: #f44336;
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
}

.cent-chip {
    background: rgb(224,224,224) none repeat scroll 0 0;
    border: none;
    border-radius: 24px;
    color: rgb(86, 86, 86);
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    line-height: 1;
    margin: 0 8px 0 0;
    padding: .7em;
    text-align: left;
    text-decoration: none;
}


ul.cent-pills {
    list-style-type: none;
    margin: 0;
    padding: 0;
    font-size: .8em;
    display: flex;
}

ul.cent-pills li {
  background: rgb(224,224,224) none repeat scroll 0 0;
  border: none;
  border-radius: 24px;
  color: rgb(86, 86, 86);
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  margin: 0 24px 0 0;
  padding: 4px 12px;
  text-align: left;
  text-decoration: none;
}

ul.cent-pills li span {
  display: block;
  padding: 5px 0;
  height: 18px;
  float: left;
  line-height: 24px;
  font-size: 16px;
}

ul.cent-pills li button {
  margin: 4px 0 4px 16px !important;
}

ul.cent-pills li a:link,
ul.cent-pills li a:active,
ul.cent-pills li a:visited {
    color: #696969;
    text-decoration: none;
}
ul.cent-pills li a:hover {
    color: #696969;
    text-decoration: none;
}

.profile div {
    line-height: 24px;
}

.profile span {
     display: inline-block;
     margin-right: 10px;
}

.profile span.roles {
    float: left;
}


.toolbar svg {
    fill: #FFF !important;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 0.75rem;
  line-height: 1; }

.ct-chart-line .ct-label, .ct-chart-bar .ct-label {
  display: block;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex; }

.ct-label.ct-horizontal.ct-start {
  -webkit-box-align: flex-end;
  -webkit-align-items: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
  -webkit-box-pack: flex-start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start; }

.ct-label.ct-horizontal.ct-end {
  -webkit-box-align: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-pack: flex-start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start; }

.ct-label.ct-vertical.ct-start {
  -webkit-box-align: flex-end;
  -webkit-align-items: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
  -webkit-box-pack: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end; }

.ct-label.ct-vertical.ct-end {
  -webkit-box-align: flex-end;
  -webkit-align-items: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
  -webkit-box-pack: flex-start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start; }

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  -webkit-box-align: flex-end;
  -webkit-align-items: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  text-anchor: start; }

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  -webkit-box-align: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  text-anchor: start; }

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  -webkit-box-align: flex-end;
  -webkit-align-items: flex-end;
  -ms-flex-align: flex-end;
  align-items: flex-end;
  -webkit-box-pack: flex-start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start; }

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  -webkit-box-align: flex-start;
  -webkit-align-items: flex-start;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  -webkit-box-pack: flex-start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start; }

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: flex-end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end; }

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: flex-start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end; }

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px; }

.ct-point {
  stroke-width: 10px;
  stroke-linecap: round; }

.ct-line {
  fill: none;
  stroke-width: 4px; }

.ct-area {
  stroke: none;
  fill-opacity: 0.1; }

.ct-bar {
  fill: none;
  stroke-width: 10px;
}
.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}
.ct-series-a .ct-point,
.ct-series-a .ct-line,
.ct-series-a .ct-bar,
.ct-series-a .ct-slice-donut {
  stroke: #d70206;
}
.ct-series-a .ct-slice-pie,
.ct-series-a .ct-area {
  fill: #d70206;
}
.ct-series-b .ct-point,
.ct-series-b .ct-line,
.ct-series-b .ct-bar,
.ct-series-b .ct-slice-donut {
  stroke: #f05b4f; }
.ct-series-b .ct-slice-pie,
.ct-series-b .ct-area {
  fill: #f05b4f;
}
.ct-series-c .ct-point,
.ct-series-c .ct-line,
.ct-series-c .ct-bar,
.ct-series-c .ct-slice-donut {
  stroke: #f4c63d;
}
.ct-series-c .ct-slice-pie,
.ct-series-c .ct-area {
  fill: #f4c63d;
}
.ct-series-d .ct-point,
.ct-series-d .ct-line,
.ct-series-d .ct-bar,
.ct-series-d .ct-slice-donut {
  stroke: #d17905;
}
.ct-series-d .ct-slice-pie,
.ct-series-d .ct-area {
  fill: #d17905;
}
.ct-series-e .ct-point,
.ct-series-e .ct-line,
.ct-series-e .ct-bar,
.ct-series-e .ct-slice-donut {
  stroke: #453d3f;
}
.ct-series-e .ct-slice-pie,
.ct-series-e .ct-area {
  fill: #453d3f;
}
.ct-series-f .ct-point,
.ct-series-f .ct-line,
.ct-series-f .ct-bar,
.ct-series-f .ct-slice-donut {
  stroke: #59922b;
}
.ct-series-f .ct-slice-pie,
.ct-series-f .ct-area {
  fill: #59922b;
}
.ct-series-g .ct-point,
.ct-series-g .ct-line,
.ct-series-g .ct-bar,
.ct-series-g .ct-slice-donut {
  stroke: #0544d3;
}
.ct-series-g .ct-slice-pie,
.ct-series-g .ct-area {
  fill: #0544d3;
}
.ct-series-h .ct-point,
.ct-series-h .ct-line,
.ct-series-h .ct-bar,
.ct-series-h .ct-slice-donut {
  stroke: #6b0392;
}
.ct-series-h .ct-slice-pie,
.ct-series-h .ct-area {
  fill: #6b0392;
}
.ct-series-i .ct-point,
.ct-series-i .ct-line,
.ct-series-i .ct-bar,
.ct-series-i .ct-slice-donut {
  stroke: #f05b4f;
}
.ct-series-i .ct-slice-pie,
.ct-series-i .ct-area {
  fill: #f05b4f;
}
.ct-series-j .ct-point,
.ct-series-j .ct-line,
.ct-series-j .ct-bar,
.ct-series-j .ct-slice-donut {
  stroke: #dda458;
}
.ct-series-j .ct-slice-pie,
.ct-series-j .ct-area {
  fill: #dda458;
}
.ct-series-k .ct-point,
.ct-series-k .ct-line,
.ct-series-k .ct-bar,
.ct-series-k .ct-slice-donut {
  stroke: #eacf7d;
}
.ct-series-k .ct-slice-pie,
.ct-series-k .ct-area {
  fill: #eacf7d;
}
.ct-series-l .ct-point,
.ct-series-l .ct-line,
.ct-series-l .ct-bar,
.ct-series-l .ct-slice-donut {
  stroke: #86797d;
}
.ct-series-l .ct-slice-pie,
.ct-series-l .ct-area {
  fill: #86797d;
}
.ct-series-m .ct-point,
.ct-series-m .ct-line,
.ct-series-m .ct-bar,
.ct-series-m .ct-slice-donut {
  stroke: #b2c326;
}
.ct-series-m .ct-slice-pie,
.ct-series-m .ct-area {
  fill: #b2c326;
}
.ct-series-n .ct-point,
.ct-series-n .ct-line,
.ct-series-n .ct-bar,
.ct-series-n .ct-slice-donut {
  stroke: #6188e2;
}
.ct-series-n .ct-slice-pie,
.ct-series-n .ct-area {
  fill: #6188e2;
}
.ct-series-o .ct-point,
.ct-series-o .ct-line,
.ct-series-o .ct-bar,
.ct-series-o .ct-slice-donut {
  stroke: #a748ca;
}
.ct-series-o .ct-slice-pie,
.ct-series-o .ct-area {
  fill: #a748ca;
}
.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 100%;
}
.ct-square:after {
    content: "";
    display: table;
    clear: both;
}
.ct-square > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 93.75%;
}
.ct-minor-second:after {
    content: "";
    display: table;
    clear: both;
}
.ct-minor-second > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 88.8888888889%;
}
.ct-major-second:after {
    content: "";
    display: table;
    clear: both;
}
.ct-major-second > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 83.3333333333%;
}
.ct-minor-third:after {
    content: "";
    display: table;
    clear: both;
}
.ct-minor-third > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 80%;
}
.ct-major-third:after {
    content: "";
    display: table;
    clear: both;
}
.ct-major-third > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 75%;
}
.ct-perfect-fourth:after {
    content: "";
    display: table;
    clear: both;
}
.ct-perfect-fourth > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 66.6666666667%;
}
.ct-perfect-fifth:after {
    content: "";
    display: table;
    clear: both;
}
.ct-perfect-fifth > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
    content: "";
    display: table;
    clear: both;
}
.ct-minor-sixth > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 61.804697157%;
}
.ct-golden-section:after {
    content: "";
    display: table;
    clear: both;
}
.ct-golden-section > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 60%;
}
.ct-major-sixth:after {
    content: "";
    display: table;
    clear: both;
}
.ct-major-sixth > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%; }
.ct-minor-seventh:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
    content: "";
    display: table;
    clear: both;
}
.CodeMirror{
  font-family:monospace;
  height:300px;
  color:#000
}
.CodeMirror-lines{padding:4px 0}
.CodeMirror pre{padding:0 4px}
.CodeMirror-gutter-filler,
.CodeMirror-scrollbar-filler{background-color:#fff}
.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}
.CodeMirror-linenumber{
  padding:0 3px 0 5px;
  min-width:20px;
  text-align:right;color:#999;
  -moz-box-sizing:content-box;
  box-sizing:content-box
}
.CodeMirror-guttermarker{color:#000}
.CodeMirror-guttermarker-subtle{color:#999}
.CodeMirror div.CodeMirror-cursor{border-left:1px solid #000}
.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}
.CodeMirror.cm-fat-cursor div.CodeMirror-cursor{width:auto;border:0;background:#7e7}
.CodeMirror.cm-fat-cursor div.CodeMirror-cursors{z-index:1}
.cm-animate-fat-cursor{
  width:auto;border:0;
  -webkit-animation:blink 1.06s steps(1) infinite;
  -moz-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite}@-moz-keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}@-webkit-keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}@keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-ruler{border-left:1px solid #ccc;position:absolute}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}
  .cm-s-default .cm-number{color:#164}
  .cm-s-default .cm-def{color:#00f}
  .cm-s-default .cm-variable-2{color:#05a}
  .cm-s-default .cm-variable-3{color:#085}
  .cm-s-default .cm-comment{color:#a50}
  .cm-s-default .cm-string{color:#a11}
  .cm-s-default .cm-string-2{color:#f50}
  .cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}
  .cm-s-default .cm-builtin{color:#30a}
  .cm-s-default .cm-bracket{color:#997}
  .cm-s-default .cm-tag{color:#170}
  .cm-s-default .cm-attribute{color:#00c}
  .cm-s-default .cm-header{color:#00f}
  .cm-s-default .cm-quote{color:#090}
  .cm-s-default .cm-hr{color:#999}
  .cm-s-default .cm-link{color:#00c}
  .cm-negative{color:#d44}
  .cm-positive{color:#292}
  .cm-header,.cm-strong{font-weight:700}
  .cm-em{font-style:italic}
  .cm-link{text-decoration:underline}
  .cm-strikethrough{text-decoration:line-through}
  .cm-invalidchar,.cm-s-default .cm-error{color:red}
  div.CodeMirror span.CodeMirror-matchingbracket{color:#0f0}
  div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#f22}
  .CodeMirror-matchingtag{background:rgba(255,150,0,.3)}
  .CodeMirror-activeline-background{background:#e8f2ff}
  .CodeMirror{position:relative;overflow:hidden;background:#fff}
  .CodeMirror-scroll{overflow:scroll!important;margin-bottom:-30px;margin-right:-30px;padding-bottom:30px;height:100%;outline:0;position:relative;-moz-box-sizing:content-box;box-sizing:content-box}
  .CodeMirror-sizer{position:relative;border-right:30px solid transparent;-moz-box-sizing:content-box;box-sizing:content-box}
  .CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none}
  .CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}
  .CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}
  .CodeMirror-scrollbar-filler{right:0;bottom:0}
  .CodeMirror-gutter-filler{left:0;bottom:0}
  .CodeMirror-gutters{position:absolute;left:0;top:0;z-index:3}
  .CodeMirror-gutter{white-space:normal;height:100%;-moz-box-sizing:content-box;box-sizing:content-box;display:inline-block;margin-bottom:-30px}
  .CodeMirror-gutter-wrapper{position:absolute;z-index:4;height:100%}
  .CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}
  .CodeMirror-gutter-wrapper{-webkit-user-select:none;-moz-user-select:none;user-select:none}
  .CodeMirror-lines{cursor:text;min-height:1px}
  .CodeMirror pre{-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;border-width:0;background:0 0;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent}
  .CodeMirror-wrap pre{word-wrap:break-word;white-space:pre-wrap;word-break:normal}
  .CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}
  .CodeMirror-linewidget{position:relative;z-index:2;overflow:auto}
  .CodeMirror-code{outline:0}
  .CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}
  .CodeMirror-measure pre{position:static}
  .CodeMirror div.CodeMirror-cursor{position:absolute;border-right:none;width:0}
  div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}
  .CodeMirror-focused div.CodeMirror-cursors{visibility:visible}
  .CodeMirror-selected{background:#d9d9d9}
  .CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}
  .CodeMirror-crosshair{cursor:crosshair}
  .CodeMirror ::selection{background:#d7d4f0}
  .CodeMirror ::-moz-selection{background:#d7d4f0}
  .cm-searching{background:#ffa;background:rgba(255,255,0,.4)}
  .cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}
  .cm-tab-wrap-hack:after{content:''}
  span.CodeMirror-selectedtext{background:0 0}
.ct-minor-seventh > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 53.3333333333%;
}
.ct-major-seventh:after {
    content: "";
    display: table;
    clear: both;
}
.ct-major-seventh > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 50%;
}
.ct-octave:after {
    content: "";
    display: table;
    clear: both;
}
.ct-octave > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 40%;
  }
.ct-major-tenth:after {
    content: "";
    display: table;
    clear: both;
  }
.ct-major-tenth > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
    content: "";
    display: table;
    clear: both;
}
.ct-major-eleventh > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 33.3333333333%;
}
.ct-major-twelfth:after {
    content: "";
    display: table;
    clear: both;
}
.ct-major-twelfth > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
    display: block;
    float: left;
    content: "";
    width: 0;
    height: 0;
    padding-bottom: 25%;
}
.ct-double-octave:after {
    content: "";
    display: table;
    clear: both;
}
.ct-double-octave > svg {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}

.cent-card-calendar {
  height: 600px;
}


/* react-big-calendar custom */
.rbc-toolbar-label {
  font-size: 1rem;
  color: rgb(117, 117, 117);
}
.rbc-toolbar button {
  text-transform: uppercase;
  font-size: .8rem;
  color: rgb(117, 117, 117);
  display: inline-block;
  margin: 0 8px 0 0;
  text-align: center;
  vertical-align: middle;
  background: none;
  background-image: none;
  border: none;
  padding: .375rem 1rem;
  border-radius: 4px;
  line-height: normal;
  white-space: nowrap;
}
.rbc-btn-group>button:first-child {
  border-radius: 0;
}
.rbc-btn-group>button:last-child {
  border-radius: 0;
  margin: 0;
}
.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: none;
  background-color: #e6e6e6;
  border: none;
}
.rbc-toolbar button:active:hover,
.rbc-toolbar button.rbc-active:hover,
.rbc-toolbar button:active:focus,
.rbc-toolbar button.rbc-active:focus {
  color: rgb(117, 117, 117);
  background-color: #e6e6e6;
  border: none;
}
.rbc-header {
  padding: 2px 4px;
  font-size: 1rem;
  min-height: 14px;
}
.rbc-off-range {
  color: #b3b3b3;
  background-color: #F5F5F5;
  border-left: 1px solid #DDD;
}
.rbc-off-range-bg {
  background-color: #F5F5F5;
}
.rbc-off-range:first-child {
  border-left: 0px;
}
.rbc-date-cell.rbc-now a {
  color: rgb(35, 151, 190);
}
.rbc-current-time-indicator {
  background-color: rgb(89, 186, 80)!important;
}
.rbc-row-segment {
  padding: 1px 1px 0 1px;
}
.rbc-event {
  padding: 4px;
  color: rgb(117, 117, 117);
  background-color: #AEE9FB;
  border-radius: 2px;
  margin: 0 1px 1px 2px;
}
.rbc-show-more {
  background-color: rgba(255,255,255,0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
  padding: 8px;
}
.rbc-overlay {
  padding: 16px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12);
  border-radius: 2px;
  border: none;
}
.rbc-day-slot .rbc-event {
  border: none!important;
  margin-right: 8px!important;
}
.rbc-day-slot .rbc-event-label {
  padding: 8px;
}
.rbc-day-slot .rbc-event-content {
  padding: 8px;
}
.rbc-event-overlaps {
}
.rbc-overlay-header {
  border-bottom: none;
  margin: 0 0 16px 0;
  padding: 0;
}
.rbc-time-slot {
  min-height: 40px;
}


/* formatting for overlapped events */
.rbc-events-container {
  display: grid;
  grid-template-rows: repeat(96, 20.25px);
}
.rbc-day-slot .rbc-event {
  position: static;
}
.rbc-day-slot .rbc-event--global {
  background-color: #fbab18;
}
.rbc-day-slot .rbc-event--regional {
  background-color: #6ebe4a;
}
/* react-big-calendar custom end */

/*  react-calendar-timeline custom */
.rct-item {
  background: rgba(35, 151, 190, 1)!important;
  border-color: rgba(35, 151, 190, 1)!important;
  border-radius: 5px;
}
.rct-sidebar-header {
  background: rgba(255, 255, 255, 1)!important;
}
.rct-sidebar-row {
padding: 0 8px!important;
}
.rct-label-group {
  background: rgba(255, 255, 255, 1)!important;
  color: rgba(117, 117, 117, 1)!important;
  border-left: 2px solid rgba(117, 117, 117, .5)!important;
  border-bottom: 1px solid rgba(255, 255, 255, 1)!important;
}
.rct-label {
  background: rgba(35, 151, 190, 1)!important;
  color: rgba(255, 255, 255, 1)!important;
  border-left: 2px solid rgba(255, 255, 255, 1)!important;
  border-bottom: 1px solid rgba(255, 255, 255, 1)!important;
}
.react-calendar-timeline .rct-today {
  background-color: rgb(89, 186, 80)!important;
}

/*  react-calendar-timeline custom end  */


  /* styles full and light colours */
.style_a {color: #fff; background: #EF5350;}  /* red 400 */
.style_a_ {color: #fff; background: #EF9A9A;} /* red 200 */
.style_b {color: #fff; background: #F57F17;}  /* yellow 900 */
.style_b_ {color: #fff; background: #FBC02D;} /* yellow 700 */
.style_c {color: #fff; background: #01579B;}  /* light blue 900 */
.style_c_ {color: #fff; background: #0288D1;} /* light blue 700 */
.style_d {color: #fff; background: #5E35B1;}  /* deep purple 600 */
.style_d_ {color: #fff; background: #7E57C2;} /* deep purple 400 */
.style_e {color: #fff; background: #FBC02D;}
.style_e_ {color: #fff; background: #FBC02D;}
.style_f {color: #fff; background: #FBC02D;}
.style_f_ {color: #fff; background: #FBC02D;}
.style_g {color: #fff; background: #FBC02D;}
.style_g_ {color: #fff; background: #FBC02D;}
.style_h {color: #fff; background: #FBC02D;}
.style_h_ {color: #fff; background: #FBC02D;}
.style_i {color: #fff; background: #FBC02D;}
.style_i_ {color: #fff; background: #FBC02D;}
.style_j {color: #fff; background: #FBC02D;}
.style_j_ {color: #fff; background: #FBC02D;}
.style_k {color: #fff; background: #FBC02D;}
.style_k_ {color: #fff; background: #FBC02D;}
.style_l {color: #fff; background: #FBC02D;}
.style_l_ {color: #fff; background: #FBC02D;}
.style_m {color: #fff; background: #FBC02D;}
.style_m_ {color: #fff; background: #FBC02D;}
.style_n {color: #fff; background: #FBC02D;}
.style_n_ {color: #fff; background: #FBC02D;}
.style_o {color: #fff; background: #FBC02D;}
.style_o_ {color: #fff; background: #FBC02D;}
.style_p {color: #fff; background: #FBC02D;}
.style_p_ {color: #fff; background: #FBC02D;}
.style_q {color: #fff; background: #FBC02D;}
.style_q_ {color: #fff; background: #FBC02D;}
.style_r {color: #fff; background: #FBC02D;}
.style_r_ {color: #fff; background: #FBC02D;}
.style_s {color: #fff; background: #FBC02D;}
.style_s_ {color: #fff; background: #FBC02D;}
.style_t {color: #fff; background: #FBC02D;}
.style_t_ {color: #fff; background: #FBC02D;}
.style_u {color: #fff; background: #FBC02D;}
.style_u_ {color: #fff; background: #FBC02D;}
.style_v {color: #fff; background: #FBC02D;}
.style_v_ {color: #fff; background: #FBC02D;}
.style_w {color: #fff; background: #FBC02D;}
.style_w_ {color: #fff; background: #FBC02D;}
.style_x {color: #fff; background: #FBC02D;}
.style_x_ {color: #fff; background: #FBC02D;}
.style_y {color: #fff; background: #FBC02D;}
.style_y_ {color: #fff; background: #FBC02D;}
.style_z {color: #fff; background: #FBC02D;}
.style_z_ {color: #fff; background: #FBC02D;}
.style_0 {color: #fff; background: #FBC02D;}
.style_0_ {color: #fff; background: #FBC02D;}
.style_1 {color: #fff; background: #FBC02D;}
.style_1_ {color: #fff; background: #FBC02D;}
.style_2 {color: #fff; background: #FBC02D;}
.style_2_ {color: #fff; background: #FBC02D;}
.style_3 {color: #fff; background: #FBC02D;}
.style_3_ {color: #fff; background: #FBC02D;}
.style_4 {color: #fff; background: #FBC02D;}
.style_4_ {color: #fff; background: #FBC02D;}
.style_5 {color: #fff; background: #FBC02D;}
.style_5_ {color: #fff; background: #FBC02D;}
.style_6 {color: #fff; background: #FBC02D;}
.style_6_ {color: #fff; background: #FBC02D;}
.style_7 {color: #fff; background: #FBC02D;}
.style_7_ {color: #fff; background: #FBC02D;}
.style_8 {color: #fff; background: #FBC02D;}
.style_8_ {color: #fff; background: #FBC02D;}
.style_9 {color: #fff; background: #FBC02D;}
.style_9_ {color: #fff; background: #FBC02D;}

button[disabled].rbc-btn{cursor:not-allowed}
button.rbc-input::-moz-focus-inner{border:0;padding:0}

.speed-dial {
  margin: 0;
  top: auto;
  right: 20px;
  bottom: 20px;
  left: auto;
  position: fixed;
  z-index: 2;
}

.speed-dial .cover {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1100; /* just above title bar */
  transition: opacity 0.2s ease-in-out;
  opacity: 1;
}

.speed-dial .closed .cover {
  opacity: 0;
  transition: opacity 0.2s ease-in-out, height 0s linear 0.2s;
}

.speed-dial .actions {
  position: absolute;
}

.speed-dial.closed .actions {
  transition: top 0s linear 0.2s;
}

.speed-dial .container {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 56px;
  text-align: center;
  z-index: 1110;
}

.speed-dial .button {
  transition: transform 0.2s ease-in-out;
}

.speed-dial.closed .button {
  transform: scale(0, 0);
}

.speed-dial .action {
  position: relative;
  margin-bottom: 20px;
}

.speed-dial .tooltip {
  position: absolute;
  right: 75px;
  top: 0.5em;
  color: black;
  background: lightgrey;
  padding: 0.5em;
  border-radius: 0.5em;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.speed-dial.closed .tooltip {
  opacity: 0;
}

.speed-dial.opened .main svg {
  transform: rotate(135deg);
}

.cent-ul-text {
  margin: 8px 32px;
  list-style-type: inherit;
}
`, "",{"version":3,"sources":["webpack://./app/css/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA,iBAAiB;AACjB,cAAc;AACd;EACE,4BAA4B;AAC9B;;AAEA,YAAY;;AAEZ;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA,uBAAuB;;AAEvB;AACA;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,qBAAqB,EAAE,WAAW;EAClC,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oCAAoC;AACtC;;;AAGA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,+EAA0E;EAC1E,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;CACC;AACD;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,qBAAqB,EAAE,WAAW;EAClC,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,aAAa,EAAE,mBAAmB;EAClC,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,mBAAmB;EAClC,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;AAC/C;;;;AAIA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa,EAAE,mBAAmB;EAClC,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;AACA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE;;;;;IAKE,WAAW;IACX,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;;IAEE,UAAU;IACV,2BAA2B;IAC3B,yCAAyC;IACzC,kEAAkE;IAClE,0BAA0B;EAC5B;EACA;;IAEE,UAAU;EACZ;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;EACA;;;;;IAKE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,2BAA2B;IAC3B,yCAAyC;IACzC,kEAAkE;IAClE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa,EAAE,mBAAmB;IAClC,eAAe;IACf,8BAA8B;IAC9B,WAAW;;EAEb;EACA;IACE,YAAY;IACZ,QAAQ;EACV;EACA;IACE,aAAa,EAAE,mBAAmB;IAClC,eAAe;IACf,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;;AAEF;;AAEA,+CAA+C;AAC/C;EACE;;;;;IAKE,UAAU;IACV,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;AAEF;;AAEA,kCAAkC;AAClC;;AAEA;;AAEA,iCAAiC;AACjC;;AAEA;;AAEA,qCAAqC;AACrC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,WAAW;AACb;;AAEA;;EAEE;IACE,gCAAgC;IAChC,oBAAoB;IACpB,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;EACA;;;;;IAKE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,+BAA+B;IAC/B,0BAA0B;EAC5B;CACD;GACE,sBAAsB;GACtB,kCAAkC;GAClC,+BAA+B;GAC/B,0BAA0B;CAC5B;AACD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,wDAAwD;AAC5D;;AAEA;IACI,mDAAmD;IACnD,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;;;AAGA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,eAAe;IACf,aAAa;AACjB;;AAEA;EACE,mDAAmD;EACnD,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;KACK,qBAAqB;KACrB,kBAAkB;AACvB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc,EAAE;;AAElB;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa,EAAE;;AAEjB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,0BAA0B;EAC1B,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB,EAAE;;AAEpB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB,EAAE;;AAEtB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB,EAAE;;AAEtB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB,EAAE;;AAEpB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB,EAAE;;AAEpB;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB,EAAE;;AAEzB;EACE,kBAAkB;EAClB,qBAAqB,EAAE;;AAEzB;EACE,UAAU;EACV,iBAAiB,EAAE;;AAErB;EACE,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe,EAAE;AACnB;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;;;;EAIE,eAAe;AACjB;AACA;;EAEE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW,EAAE;AACf;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ;AACF;AACA,kBAAkB,aAAa;AAC/B,gBAAgB,aAAa;AAC7B;6BAC6B,qBAAqB;AAClD,oBAAoB,2BAA2B,CAAC,wBAAwB,CAAC,kBAAkB;AAC3F;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB,CAAC,UAAU;EAC3B,2BAA2B;EAC3B;AACF;AACA,yBAAyB,UAAU;AACnC,gCAAgC,UAAU;AAC1C,kCAAkC,0BAA0B;AAC5D,2CAA2C,4BAA4B;AACvE,gDAAgD,UAAU,CAAC,QAAQ,CAAC,eAAe;AACnF,iDAAiD,SAAS;AAC1D;EACE,UAAU,CAAC,QAAQ;EACnB,+CAA+C;EAC/C,4CAA4C,CAAC,uCAAuC,CAAC,sBAAsB,GAAG,eAAe,CAAC,IAAI,cAAc,CAAC,KAAK,eAAe,CAAC,CAAC,yBAAyB,GAAG,eAAe,CAAC,IAAI,cAAc,CAAC,KAAK,eAAe,CAAC,CAAC,iBAAiB,GAAG,eAAe,CAAC,IAAI,cAAc,CAAC,KAAK,eAAe,CAAC,CAAC,QAAQ,oBAAoB,CAAC,uBAAuB,CAAC,kBAAkB,0BAA0B,CAAC,iBAAiB,CAAC,0BAA0B,UAAU,CAAC,uBAAuB,UAAU;EACngB,yBAAyB,UAAU;EACnC,sBAAsB,UAAU;EAChC,6BAA6B,UAAU;EACvC,6BAA6B,UAAU;EACvC,0BAA0B,UAAU;EACpC,yBAAyB,UAAU;EACnC,2BAA2B,UAAU;EACrC,mDAAmD,UAAU;EAC7D,0BAA0B,UAAU;EACpC,0BAA0B,UAAU;EACpC,sBAAsB,UAAU;EAChC,4BAA4B,UAAU;EACtC,yBAAyB,UAAU;EACnC,wBAAwB,UAAU;EAClC,qBAAqB,UAAU;EAC/B,uBAAuB,UAAU;EACjC,aAAa,UAAU;EACvB,aAAa,UAAU;EACvB,sBAAsB,eAAe;EACrC,OAAO,iBAAiB;EACxB,SAAS,yBAAyB;EAClC,kBAAkB,4BAA4B;EAC9C,wCAAwC,SAAS;EACjD,+CAA+C,UAAU;EACzD,kDAAkD,UAAU;EAC5D,wBAAwB,6BAA6B;EACrD,kCAAkC,kBAAkB;EACpD,YAAY,iBAAiB,CAAC,eAAe,CAAC,eAAe;EAC7D,mBAAmB,yBAAyB,CAAC,mBAAmB,CAAC,kBAAkB,CAAC,mBAAmB,CAAC,WAAW,CAAC,SAAS,CAAC,iBAAiB,CAAC,2BAA2B,CAAC,sBAAsB;EAClM,kBAAkB,iBAAiB,CAAC,mCAAmC,CAAC,2BAA2B,CAAC,sBAAsB;EAC1H,qGAAqG,iBAAiB,CAAC,SAAS,CAAC,YAAY;EAC7I,uBAAuB,OAAO,CAAC,KAAK,CAAC,iBAAiB,CAAC,iBAAiB;EACxE,uBAAuB,QAAQ,CAAC,MAAM,CAAC,iBAAiB,CAAC,iBAAiB;EAC1E,6BAA6B,OAAO,CAAC,QAAQ;EAC7C,0BAA0B,MAAM,CAAC,QAAQ;EACzC,oBAAoB,iBAAiB,CAAC,MAAM,CAAC,KAAK,CAAC,SAAS;EAC5D,mBAAmB,kBAAkB,CAAC,WAAW,CAAC,2BAA2B,CAAC,sBAAsB,CAAC,oBAAoB,CAAC,mBAAmB;EAC7I,2BAA2B,iBAAiB,CAAC,SAAS,CAAC,WAAW;EAClE,uBAAuB,iBAAiB,CAAC,cAAc,CAAC,SAAS;EACjE,2BAA2B,wBAAwB,CAAC,qBAAqB,CAAC,gBAAgB;EAC1F,kBAAkB,WAAW,CAAC,cAAc;EAC5C,gBAAgB,oBAAoB,CAAC,uBAAuB,CAAC,eAAe,CAAC,cAAc,CAAC,cAAc,CAAC,mBAAmB,CAAC,iBAAiB,CAAC,QAAQ,CAAC,eAAe,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,aAAa,CAAC,SAAS,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,uCAAuC;EACjT,qBAAqB,oBAAoB,CAAC,oBAAoB,CAAC,iBAAiB;EAChF,2BAA2B,iBAAiB,CAAC,MAAM,CAAC,OAAO,CAAC,KAAK,CAAC,QAAQ,CAAC,SAAS;EACpF,uBAAuB,iBAAiB,CAAC,SAAS,CAAC,aAAa;EAChE,iBAAiB,SAAS;EAC1B,oBAAoB,iBAAiB,CAAC,UAAU,CAAC,QAAQ,CAAC,eAAe,CAAC,iBAAiB;EAC3F,wBAAwB,eAAe;EACvC,kCAAkC,iBAAiB,CAAC,iBAAiB,CAAC,OAAO;EAC7E,uBAAuB,iBAAiB,CAAC,iBAAiB,CAAC,SAAS;EACpE,2CAA2C,kBAAkB;EAC7D,qBAAqB,kBAAkB;EACvC,yCAAyC,kBAAkB;EAC3D,sBAAsB,gBAAgB;EACtC,wBAAwB,kBAAkB;EAC1C,6BAA6B,kBAAkB;EAC/C,cAAc,eAAe,CAAC,6BAA6B;EAC3D,iBAAiB,kBAAkB,CAAC,aAAa,mCAAmC,iBAAiB,CAAC;EACtG,wBAAwB,UAAU;EAClC,6BAA6B,cAAc;AAC7C;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;AACF;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;EACrB;AACF;IACI,WAAW;IACX,cAAc;IACd,WAAW;EACb;AACF;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;AACF;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;EACE,aAAa;AACf;;;AAGA,8BAA8B;AAC9B;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;AACA;;;;EAIE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,uCAAuC;EACvC,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,kEAAkE;EAClE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;AACA;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;;;AAGA,qCAAqC;AACrC;EACE,aAAa;EACb,uCAAuC;AACzC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,kCAAkC;;AAElC,oCAAoC;AACpC;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA;AACA,wBAAwB;AACxB;AACA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,wDAAwD;EACxD,yDAAyD;AAC3D;AACA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,uDAAuD;EACvD,yDAAyD;AAC3D;AACA;EACE,4CAA4C;AAC9C;;AAEA,yCAAyC;;;EAGvC,kCAAkC;AACpC,UAAU,WAAW,EAAE,mBAAmB,CAAC,GAAG,YAAY;AAC1D,WAAW,WAAW,EAAE,mBAAmB,CAAC,EAAE,YAAY;AAC1D,UAAU,WAAW,EAAE,mBAAmB,CAAC,GAAG,eAAe;AAC7D,WAAW,WAAW,EAAE,mBAAmB,CAAC,EAAE,eAAe;AAC7D,UAAU,WAAW,EAAE,mBAAmB,CAAC,GAAG,mBAAmB;AACjE,WAAW,WAAW,EAAE,mBAAmB,CAAC,EAAE,mBAAmB;AACjE,UAAU,WAAW,EAAE,mBAAmB,CAAC,GAAG,oBAAoB;AAClE,WAAW,WAAW,EAAE,mBAAmB,CAAC,EAAE,oBAAoB;AAClE,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;AAC5C,UAAU,WAAW,EAAE,mBAAmB,CAAC;AAC3C,WAAW,WAAW,EAAE,mBAAmB,CAAC;;AAE5C,yBAAyB,kBAAkB;AAC3C,mCAAmC,QAAQ,CAAC,SAAS;;AAErD;EACE,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;EACN,OAAO;EACP,aAAa,EAAE,yBAAyB;EACxC,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":[":root {\n  font-size: 18px;\n}\nbody {\n  background-color: rgb(245,245,245);\n  margin: 0 !important;\n  color: rgb(117, 117, 117);\n  font-family: Roboto, sans-serif;\n}\narticle {\n  clear: both;\n}\n\na:link,\na:visited {\n  text-decoration: none;\n  color: rgba(0, 0, 0, 0.54);\n}\n\na.a-block {\n  display: block;\n  width: 100%;\n}\n\np,h1,h2,h4 {\n  color: rgb(117, 117, 117);\n}\nh2 {\n  font-weight: 500;\n  font-size: 1.5rem;\n}\nh3 {\n  font-weight: 500;\n  font-size: 1.17rem;\n  margin-bottom: 6px;\n}\nh4 {\n  font-weight: 600;\n  font-size: .8rem;\n  margin: 6px 0 4px 0;\n  padding: 0;\n}\np {\n  margin: 4px 0;\n  padding:0;\n  line-height: 1.2rem;\n  font-size: .8rem;\n}\n\np a:link,\np a:visited,\np a:active  {\n  color: rgb(35, 151, 190);\n}\n\np a:hover  {\n  text-decoration: underline;\n  color: rgb(35, 151, 190);\n}\n\np.subHeading {\n  color: rgba(117, 117, 117 ,0.5);\n  margin-bottom: 4px;\n  display: block;\n  width: 100%;\n}\n\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  color: rgb(117, 117, 117);\n}\n\nul li {\n  margin: 6px 0;\n  padding: 0;\n}\n\n.header-wrapper {}\n.cent-layout {}\n.cent-main {\n  padding-top: 64px !important;\n}\n\n.cent-form {}\n\n.cent-form h2 {\n  font-size: 1.1rem;\n  font-weight: 400;\n  margin: 16px 0 0 0;\n  display: block;\n  width: 100%;\n}\n.cent-form-element-number {\n  text-align: right;\n}\n\n/* Legacy support */\n.centric-content {\n  text-align: center;\n  width: 70%;\n  margin: 0 auto;\n  padding-top: 64px !important;\n}\n.centric-footer {\n  background: black;\n  color: white;\n  padding: 40px 0;\n  bottom: 0;\n  width: 100%;\n  text-align: center;\n}\n.centric-footer a {\n  color: white;\n  text-decoration: none;\n}\n#execptionMessage {\n  background-color: #FFF;\n  color: rgb(117, 117, 117);\n  width: 100%;\n  padding: 16px;\n}\n#execptionMessage h2 {\n  margin: 8px;\n}\n/* Legacy support end */\n\n.cent-drawer {\n}\n\n.cent-footer {\n  background: black;\n  color: white;\n  padding: 20px 0;\n  width: 100%;\n  display: -webkit-flex; /* Safari */\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  font-size: .9rem;\n  font-weight: 300;\n  position: absolute;\n}\n\n.cent-footer .copyright {\n  color: #BCC0C0;\n  font-size: .8rem;\n  margin: 8px 0 0 0;\n  text-align: center;\n}\n\n.cent-footer .copyright a {\n  color: #BCC0C0;\n  text-decoration: none;\n}\n\n.cent-footer .copyright a:hover {\n  color: #FFF;\n}\n\n.cent-footer-links li {\n  display: inline-block;\n  margin: 8px 16px;\n}\n\n.cent-footer-links a {\n  color: #BCC0C0;\n  text-decoration: none;\n}\n\n.cent-footer-links a:hover {\n  color: #FFF;\n}\n\n\nul.cent-list-plain.category-tree ul {\n  padding-left: 2em;\n}\n\n.cent-list-plain li {\n  margin: 4px 0;\n  padding: 0;\n  line-height: 1.2rem;\n  font-size: .8rem;\n}\n\n.cent-list-plain li em {\n  font-weight: 600;\n  width: 33%;\n  display: inline-block;\n  font-style: normal;\n}\n\n.cent-list-plain a:link,\n.cent-list-plain a:visited,\n.cent-list-plain a:active  {\n  color: rgb(35, 151, 190);\n}\n\n.cent-list-plain a:hover  {\n  text-decoration: underline;\n  color: rgb(35, 151, 190);\n}\n\n\n.cent-list-item {\n  padding: 8px;\n  height: 40px;\n}\n\n.cent-list-item-text {\n  display: block;\n}\n\n.cent-list-item-avatar {\n  float: left;\n  margin: 0 16px 0 0;\n}\n\n.cent-checkbox-wrapper {\n  margin: 16px 0 0 0 ;\n}\n\n.cent-checkbox-hint {\n  color: rgba(117, 117, 117 ,0.5);\n  font-size: 12px;\n  line-height: 2;\n  margin-bottom: 4px;\n}\n\n.cent-radio-button-group {\n  padding: 1em;\n}\n\n.cent-radio-button-group > div {\n  margin-top: 0.5em;\n}\n\n.avatar{\n  background-color: rgb(35, 151, 190);\n}\n.avatar-required {\n  background-color: rgb(183, 28, 28);\n}\n.avatar-toDo {\n  background-color: rgb(255, 171, 0);\n}\n.avatar-toDo-required {\n  background-color: rgb(183, 28, 28);\n}\n.avatar-inProgress {\n  background-color: rgb(255, 215, 64);\n}\n.avatar-inProgress-required {\n  background-color: rgb(255, 215, 64);\n}\n.avatar-completed {\n  background-color: rgb(76, 175, 80);\n}\n.avatar-disabled {\n  background-color: rgb(189, 189, 189);\n}\n\n\n.primaryText {\n  font-weight: 500;\n  display: block;\n}\n.secondaryText {\n  display: block;\n  line-height: 1.3em!important;\n  margin-top: 2px!important;\n}\n.secondaryInfo {\n  height: 40px;\n  margin-top: 8px!important;\n}\n\n#centIdentifier {\n  display: block;\n  padding: 16px;\n  background: #eef3f4 url(\"../img/bg-drawer-header.png\") no-repeat right top;\n  margin: 0 0 16px 0!important;\n}\n\n.cent-username a {\n  color: #FFF !important;\n  display: block;\n  clear: none;\n  margin: 16px 0;\n}\n\n.cent-progressLabel {\n  clear: none;\n  float: left;\n  padding: 16px;\n  margin: 8px 8px 16px 16px;\n}\n\n.cent-progressLabel-text {\n display: inline;\n}\n\n.progressBar {\n  margin: 0 0 4px 0;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  border: none;\n  height: 12px;\n  line-height: 12px;\n  background-color: rgb(239, 239, 239);\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n}\n.progressBar .segment {\n  display: inline;\n  flex-grow: 1;\n  border: none;\n  background-color: #FFF;\n  height: 12px;\n  margin: 0;\n  line-height: 10px;\n}\n\n.progressBar > :first-child,\n.progressBar > :first-child a {\n  -webkit-border-radius: 5px 0 0 5px;\n  -moz-border-radius: 5px 0 0 5px;\n  border-radius: 5px 0 0 5px;\n}\n\n.progressBar > :last-child,\n.progressBar > :last-child a {\n  -webkit-border-radius: 0 5px 5px 0;\n  -moz-border-radius: 0 5px 5px 0;\n  border-radius: 0 5px 5px 0;\n}\n\n.progressBar > :only-child,\n.progressBar > :only-child a {\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n}\n\n.progressBar .segment a {\n  display: block;\n  height: 12px;\n  width: 100%;\n}\n.progressBar .segment a:hover {\n  background-color: #FFF;\n}\n.progressBar .segment.canceled {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.canceled a:hover {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.waiting {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.waiting a:hover {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.enrolled {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.enrolled a:hover {\n  background-color: rgb(239, 239, 239);\n}\n\n.progressBar .segment.completed {\n  background-color: rgb(35, 151, 190);\n}\n.progressBar .segment.completed a:hover {\n  background-color: rgb(57, 170, 211);\n}\n.progressBar .segment.partial {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.partial a:hover {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.none {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar .segment.none a:hover {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar.requirements .segment.partial {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar.requirements .segment.partial a:hover {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar.requirements .segment.none {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar.requirements .segment.none a:hover {\n  background-color: rgb(239, 239, 239);\n}\n\n.progressBar.cancelled .segment {\n  background-color: #E0E0E0;\n}\n.progressBar.cancelled .segment a:hover {\n  background-color: #E0E0E0;\n}\n.progressBar.cancelled .segment.completed {\n  background-color: #999;\n}\n.progressBar.cancelled .segment.completed a:hover {\n  background-color: #AAA;\n}\n\n.progressBar .segment.success {\n  background-color: #4CAE50;\n}\n.progressBar .segment.success a:hover {\n  background-color: #4cb54f;\n}\n.progressBar.success .segment {\n  background-color: rgb(239, 239, 239);\n}\n.progressBar.success .segment a:hover {\n  background-color: rgb(239, 239, 239);\n}\n\n.secondaryInfo .progressBar {\n  max-width: 50%;\n}\n\n.progressBar-label {\n  margin: 8px 0;\n}\n.spot {\n  display: inline-block;\n  background-color: rgba(117, 117, 117 ,0.7);\n  border-radius: 50%;\n  width: .7em;\n  height: .7em;\n  margin: 0 8px 0 8px;\n}\n.spot.spot-optional {\n  background-color: #F9B205;\n}\n.spot.spot-mandatory {\n  background-color: #B71B1C;\n}\n\n.flag-text {\n  color: #FFF;\n  background-color: rgba(117, 117, 117 ,0.7);\n  border-radius: 5px;\n  padding: 1px 5px;\n  margin: 0 8px 0 0;\n  text-transform: uppercase;\n  font-size: .8em;\n}\n\n.flag-mandatory,\n.flag-optional {\n  color: #FFF;\n  border-radius: 5px;\n  padding: 1px 4px;\n  margin: 0 8px 0 0;\n  text-transform: uppercase;\n}\n.flag-mandatory {\n  background-color: #B71B1C;\n}\n.flag-optional {\n  background-color: #F9B205;\n}\n.flag-success {\n  background-color: #4CAE50;\n}\n\n.icon-duration {\n  color: #696969;\n  background-color: #CCC;\n  border: 1px solid #CCC;\n  border-radius: 5px;\n  padding: 1px 4px;\n  margin: 0 8px 0 0;\n  display: inline-block;\n}\n\n.icon-small {\n  height: 16px!important;\n  width: 16px!important;\n  margin: 2px 8px 0 0!important;\n  padding: 0!important;\n}\n\n.icon-small-td {\n  height: 12px!important;\n  width: 12px!important;\n  margin: 0 0 0 8px!important;\n  padding: 0!important;\n}\n\n.icon-small-li {\n  height: 12px!important;\n  width: 12px!important;\n  margin: 0 8px 0 0!important;\n  padding: 0!important;\n}\n\n.icon-micro {\n  height: 12px;\n  font-size: 10px;\n  line-height: 11px;\n}\n\n.tbl-td-icon {\n  padding: 0!important;\n  text-align: center!important;\n}\n\n.tbl-td-number {\n  width: 11%!important;\n  text-align: right!important;\n}\n\n.tbl-td-actions {\n  padding: 0!important;\n  text-align: right!important;\n}\n\n.cent-container {\n  width: 90%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.cent-hero-space {\n  background-color: rgb(31, 115, 146);\n  width: 100%;\n  color: #FFF;\n}\n.cent-breadcrumbs {\n  font-size: .7rem;\n  font-weight: 300;\n  color: #FFF;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.cent-breadcrumbs li {\n  display: inline-block;\n  margin-right: 8px;\n}\n.cent-breadcrumbs li a {\n  color: #FFF;\n  text-decoration: none;\n}\n.cent-breadcrumbs li a:hover {\n  color: #FFF;\n  text-decoration: underline;\n}\n\n.cent-hero-content {\n  padding: 36px;\n  width: 70%;\n}\n.cent-hero-content h2 {\n  color: #FFF;\n  letter-spacing: 1px;\n  margin: 16px 0 16px 0;\n}\n.cent-hero-content p {\n  color: #FFF;\n  letter-spacing: 1px;\n  padding: 0 0 16px 0;\n}\n\n.cent-dialog {\n }\n.cent-dialog-text {\n  margin-bottom: 42px!important;\n}\n.cent-dialog-actions {\n  position: absolute!important;\n  display: block;\n  margin-top: 16px;\n  bottom: 8px;\n  right: 8px;\n  text-align: right;\n}\n\n.cent-cards {\n  display: -webkit-flex; /* Safari */\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 16px 0 16px 0;\n}\n.cent-cards-header {\n  width: 100%;\n  margin:  8px 8px 16px 8px;\n}\n.cent-cards-header h2{\n  margin: 0;\n}\n\n.cent-card {\n  color: rgb(117, 117, 117);\n  margin:  8px 8px 8px 8px;\n  flex-grow: 1;\n  position: relative;\n}\n.cent-card-4 {\n  width: 30%;\n}\n.cent-card-6 {\n  width: 48%;\n}\n.cent-card-6 > div {\n  height: 100%;\n}\n\n.cent-card-flex-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.cent-card-flex-title {\n  flex-grow: 1;\n}\n\n.cent-card-8 {\n  width: 66%;\n}\n.cent-card-12 {\n  width: 100%;\n}\n.cent-card-micro {\n  width: 30%;\n  margin-bottom: 4px !important;\n}\n.cent-card-list {\n  padding: 0!important;\n}\n\n.cent-card-list-item {\n  width: 48%;\n  margin-bottom: 4px !important;\n}\n\n.cent-card-header button {\n  margin: 0!important;\n}\n\n\n.cent-flex-row {\n  display: flex; /* or inline-flex */\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.cent-flex-column {\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.cent-col-1 {\n  width: 100%;\n}\n.cent-col-2 {\n  width: 50%;\n}\n.cent-col-3 {\n  width:33%;\n}\n.cent-col-4 {\n  width:34%;\n}\n.cent-col-8 {\n  width:66%;\n}\n.cent-col-12 {\n  width:100%;\n}\n\n.cent-zero {\n  padding: 0!important;\n}\n\n.cent-card-text {\n  padding-top: 0 !important;\n}\n\n.cent-card-text p {\n  margin-bottom: 16px;\n}\n\n.cent-card-text h4,\n.cent-card-text h5 {\n  margin: 4px 0;\n  padding: 0;\n}\n.cent-card-text h4 {\n  font-size: .8rem;\n  line-height: 1.2rem;\n  font-weight: 600;\n}\n.cent-card-text h5 {\n  font-size: .7rem;\n  font-weight: 300;\n}\n\n.cent-card-text h4 a:link,\n.cent-card-text h4 a:active,\n.cent-card-text h4 a:visited {\n  color: rgb(117, 117, 117);\n  text-decoration: none;\n}\n.cent-card-text h4 a:hover {\n  color: rgb(117, 117, 117);\n  text-decoration: underline;\n}\n\n.cent-card-chips,\n.cent-card-chips-r {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 16px 16px 16px!important;\n}\n.cent-card-chips-r {\n  flex-direction: row-reverse;\n}\n\n.cent-card-chips-mid {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 16px!important;\n}\n\n.cent-form-chips {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 0 16px 0!important;\n}\n\n.cent-card-actions {\n  padding: 0 16px!important;\n  text-align: right;\n}\n\n.cent-card-header-buttons {\n  position: absolute;\n  top: 0;\n  right: 0;\n  text-align: right;\n  margin: 16px;\n}\n\n.cent-card-header-buttons .cent-icon {\n  margin-left: 16px;\n}\n\n.cent-progress-bar-circular {\n  width: 180px;\n  padding: 0;\n  margin: 0 16px;\n}\n\n.button-raised {\n  margin-bottom: 16px;\n}\n\n.buttonRaised {\n  display: block;\n  width: 100%;\n  padding: 8px;\n  font-size: 1rem;\n  font-family: Roboto, sans-serif;\n  color: #FFF;\n  text-transform: uppercase;\n  letter-spacing: .2rem;\n  background-color: rgb(35, 151, 190);\n  border: solid 1px rgb(35, 151, 190);\n  border-radius: 4px;\n}\n\n.buttonRaised:hover {\n  background-color: rgb(38, 181, 214);\n}\n\n.cent-page {\n  padding: 32px;\n  margin: 0 auto 0 auto;\n  max-width: 1200px;\n}\n\n.cent-page-formal h3 {\n  margin-top: 32px;\n  margin-bottom: 8px;\n}\n\n.cent-page-formal p {\n  text-align: justify;\n}\n\n.cent-content {\n  display: flex; /* or inline-flex */\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: space-between;\n  padding: 0 16px 16px 16px;\n}\n\n.cent-content h2,\n.cent-content h3,\n.cent-content h4 {\n  padding: 0;\n  margin: 0;\n}\n.cent-content h2 {\n  font-size: 1rem;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.cent-content-white {\n  background-color: #FFF;\n}\n\n.content-left {\n  flex-grow: 1;\n  margin-right: 16px;\n  min-width: 110px;\n  max-width: 200px;\n  order: 0;\n}\n.content-main {\n  flex-grow: 3;\n  font-size: .8rem;\n  order: 2;\n}\n\n.content-main div {\n  margin: 0 0 16px 0;\n}\n\n.content-main div:first-of-type {\n  margin: 0 0 4px 0;\n}\n\n.content-main div:last-of-type {\n  margin: 0;\n}\n\n.content-right {\n  flex-grow: 1;\n  margin-left: 16px;\n  order: 3;\n}\n.content-right > div {\n  padding: 0 0 0 16px;\n  position: relative;\n  margin: 0 0 16px 0;\n  text-align: center;\n  min-width: 110px;\n}\n.cent-category {\n  position: relative;\n  padding: 16px;\n  margin: 0;\n  border-left: 16px solid rgb(31, 115, 146);\n  display: block;\n}\n.cent-category-header {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  font-weight: 500;\n}\n.cent-category-links {\n  position: relative;\n  padding: 0;\n  margin: 8px 0 0 0;\n  font-size: .89rem;\n}\n\n.cent-stat {\n  position: relative;\n  height: 60px;\n  padding: 16px;\n  margin: 0;\n  border-left: 16px solid rgb(35, 151, 190);\n}\n\n.cent-stat:hover  {\n  border-left: 16px solid rgb(57, 170, 211);\n}\n.cent-stat-count {\n  padding: 0;\n  margin: 0 0 8px 0;\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  width: 50%;\n  display: block;\n  font-size: 1.5rem;\n  font-weight: 300;\n  color: rgb(35,151,190);\n}\n.cent-stat-count a:link {\n  color: rgb(35, 151, 190);\n}\n.cent-stat-count i {\n  font-size: .8rem;\n  color: rgba(128, 134, 135, 0.54)\n}\n\n.cent-stat-title {\n  padding: 0;\n  margin: 0;\n  width: 50%;\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n  text-transform: uppercase;\n  font-size: .7rem;\n  display: inline;\n  clear: left;\n}\n\n.cent-stat-icon {\n  padding: 0;\n  margin: 16px 16px 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 60px;\n  height: 60px;\n  float: right;\n  clear: none;\n}\n\n.badge-duration {\n  color: #FFF;\n  display: block;\n  line-height: 1rem;\n  font-size: 1rem;\n  text-align: center;\n  padding: 8px;\n  margin: 0 auto;\n  border-radius: 25px;\n  background-color: rgb(117, 117, 117);\n  border: 2px solid rgb(117, 117, 117);\n}\n\n.badge-cpd {\n  color: #FFF;\n  display: block;\n  line-height: 1rem;\n  font-size: 1rem;\n  text-align: left;\n  padding: 0;\n  margin: 0 auto;\n  border-radius: 25px;\n  border: 2px solid rgb(35, 151, 190);\n  background: rgb(35, 151, 190);\n}\n\n.badge-cpd-amount {\n  display: inline-block;\n  border: 2px solid #FFF;\n  padding: 5px;\n  margin: 0 8px 0 0;\n  text-align: center;\n  min-width: 16px;\n  border-radius: 25px;\n  background-color: #FFF;\n  color: rgb(35, 151, 190);\n}\n\n.badge-score {\n  color: #CBCBCB;\n  display: block;\n  line-height: 2rem;\n  font-size: 1.3rem;\n  text-align: center;\n  padding: 0 16px;\n  margin: 0 auto;\n  border-radius: 25px;\n  background-color: #FFF;\n  border: 2px solid #FFF;\n}\n.badge-score em {\n  color: rgb(117, 117, 117);\n  font-size: 2rem;\n  margin-right: 4px;\n  font-style: normal;\n}\n\n.badge-subtitle {\n  color: #CBCBCB;\n  border-top: 2px solid #CBCBCB;\n  margin: 0;\n  padding: 0;\n  font-weight: 400;\n  font-size: .7rem;\n  text-transform: uppercase;\n}\n\n.price {\n  line-height: 1.3rem;\n  font-size: 1.2rem;\n  color: rgb(117, 117, 117);\n}\n\n.mapMarker {\n  display: block;\n  position: relative;\n}\n.mapMarker-icon {\n  position: absolute;\n  top: -32px;\n  left: -12px;\n  width: 32px;\n  height: 32px;\n}\n\n.mapMarker-title {\n  position: absolute;\n  top: -30px;\n  left: 18px;\n  width: 200px;\n  font-weight: 400;\n  font-size: 1.2em;\n  color: #000;\n}\n\n\n.cent-event {\n  color: rgb(117, 117, 117)!important;\n  background-color: rgb(174, 233, 252)!important;\n}\n.cent-event-past {\n  color: rgb(117, 117, 117)!important;\n  background-color: rgb(174, 233, 252)!important;\n}\n\n.cent-event-attendance {\n  background-color: rgb(35, 151, 190)!important;\n}\n\n\n\n.cent-schedule-segment {\n  display: block;\n}\n.cent-schedule-segment a {\n  color: #FFF;\n  text-decoration: none;\n  display: block;\n  padding: 2px;\n  background-color: rgb(35, 151, 190);\n  border-radius: 5px;\n}\n\n.profile-avatar-wrapper {\n  color: rgb(117, 117, 117);\n  display: block;\n  line-height: 30px;\n  font-size: 16px;\n  text-slign: center;\n  font-style: italic;\n  margin: 6px 0;\n}\n\n.profile-avatar {\n  margin: 0 auto;\n  width: 100px;\n  height: 100px;\n}\n\n.divider {\n  clear: both;\n}\n\n.skill-levels {\n  width: 120px;\n  height: 30px;\n  display: flex; /* or inline-flex */\n  flex-direction: row;\n  justify-content:  center;\n}\n.skill-levels > div {\n  width: 30px;\n  height:15px;\n  margin: auto;\n  background-color: rgb(112, 219, 255);\n  border: 1px solid rgb(112, 219, 255);\n  border-radius: 2px;\n}\n.skill-levels div.active {\n  background-color: rgb(35, 151, 190);\n  border: 1px solid rgb(35, 151, 190);\n}\n.skill-levels div.trainer {\n  background-color: rgb(112, 219, 255);\n  border: 1px solid rgb(112, 219, 255);\n}\n.skill-levels div.trainer.active {\n  background-color: rgb(0, 131, 143);\n  border: 1px solid rgb(0, 131, 143);\n}\n\np.version {\n  padding: 0;\n}\n\n/* Smartphones (portrait) ----------- */\n@media screen and (max-width : 400px) {\n  .cent-cards,\n  .cent-form,\n  .cent-paper,\n  .cent-list,\n  .cent-tree {\n    width: 100%;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n  .cent-card {\n    width: 96%;\n    margin: 0 auto 4px auto !important;\n  }\n  .cent-card-micro,\n  .cent-card-list-item {\n    width: 90%;\n    margin: 0 0 1px 0!important;\n    border-bottom: 1px solid rgb(220,220,220);\n    box-shadow: 0 0 0 rgba(0,0,0,0.0), 0 0 0 rgba(0,0,0,0.0)!important;\n    border-radius: 0!important;\n  }\n  .cent-col-4,\n  .cent-col-8 {\n    width:100%;\n  }\n  .toolbar-title span {\n    font-size: 1.2rem!important;\n  }\n  .cent-container {\n    width: 100%;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .cent-hero-content {\n    padding: 16px;\n    width: 100%;\n  }\n\n}\n\n@media screen and (max-width: 700px) {\n  .toolbar-title  {\n    max-width: 50%;\n    overflow: hidden;\n  }\n  .toolbar-title span {\n    font-size: 1rem!important;\n    max-width: 100%;\n  }\n\n  .cent-cards {\n    margin: 0;\n  }\n  .cent-cards,\n  .cent-form,\n  .cent-paper,\n  .cent-list,\n  .cent-tree {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n  .cent-card {\n    width: 96%;\n    margin: 0 auto 4px auto !important;\n  }\n  .cent-card-6 {\n    width: 90%;\n  }\n  .cent-card-list-item {\n    width: 90%;\n    margin: 0 0 1px 0!important;\n    border-bottom: 1px solid rgb(220,220,220);\n    box-shadow: 0 0 0 rgba(0,0,0,0.0), 0 0 0 rgba(0,0,0,0.0)!important;\n    border-radius: 0!important;\n  }\n  .cent-card-media span:first-of-type {\n    font-size: 1.1rem!important;\n  }\n  .secondaryInfo .progressBar {\n    width: 100% !important;\n    max-width: 100%;\n  }\n  .primaryText {\n    line-height: 1rem;\n  }\n  .flag-optional,\n  .flag-mandatory {\n    font-size: .7rem;\n  }\n  .cent-col-2 {\n    width: 100%;\n  }\n  .cent-card-text {\n    flex-direction: column;\n  }\n  .content-left {\n    display: flex; /* or inline-flex */\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n\n  }\n  .content-main {\n    flex-grow: 1;\n    order: 1;\n  }\n  .content-right {\n    display: flex; /* or inline-flex */\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n    margin: 16px 0 0 0;\n    order: 2;\n  }\n  .profile-avatar-wrapper {\n    float: left;\n    margin: 0 16px 0 0;\n  }\n  .login-dialog {\n    max-width: 350px !important;\n  }\n}\n\n@media screen and (max-width: 890px) {\n  .cent-col-4,\n  .cent-col-8 {\n    width:100%;\n  }\n  .cent-card-list-item {\n    width: 90%;\n    margin: 0 0 1px 0!important;\n  }\n\n}\n\n/* iPads (portrait and landscape) ----------- */\n@media only screen and (min-width : 960px) {\n  .cent-cards,\n  .cent-form,\n  .cent-paper,\n  .cent-list,\n  .cent-tree {\n    width: 90%;\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n  .cent-splash {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n}\n\n/* iPads (landscape) ----------- */\n@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {\n\n}\n\n/* iPads (portrait) ----------- */\n@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {\n\n}\n\n/* Desktops and laptops ----------- */\n@media only screen  and (min-width : 1224px) {\n  .cent-card-6 {\n    width: 30%;\n  }\n  .cent-card-list-item {\n    width: 30%;\n  }\n  .cent-card-micro {\n    width: 24%;\n  }\n}\n\n/* Large screens ----------- */\n@media only screen  and (min-width : 1824px) {\n  /* Styles */\n}\n\n@media print  {\n\n  body {\n    background-color: #FFF!important;\n    margin: 0 !important;\n    color: rgb(117, 117, 117)!important;\n  }\n  a {\n    color: rgb(117, 117, 117)!important;\n  }\n  .toolbar,\n  button {\n    display: none!important;\n  }\n  .cent-main {\n    padding-top: 0 !important;\n    margin: 0 !important;\n  }\n  .cent-cards,\n  .cent-form,\n  .cent-paper,\n  .cent-list,\n  .cent-tree {\n    width: 100%;\n    margin: 0!important;\n    border: none!important;\n    -webkit-box-shadow: none!important;\n    -moz-box-shadow: none!important;\n    box-shadow: none!important;\n  }\n .cent-card {\n   border: none!important;\n   -webkit-box-shadow: none!important;\n   -moz-box-shadow: none!important;\n   box-shadow: none!important;\n }\n}\n\n.validation-error {\n    position: relative;\n    bottom: 15px;\n    font-size: 12px;\n    line-height: 12px;\n    color: #f44336;\n    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n}\n\n.cent-chip {\n    background: rgb(224,224,224) none repeat scroll 0 0;\n    border: none;\n    border-radius: 24px;\n    color: rgb(86, 86, 86);\n    display: inline-block;\n    font-size: 14px;\n    font-weight: normal;\n    line-height: 1;\n    margin: 0 8px 0 0;\n    padding: .7em;\n    text-align: left;\n    text-decoration: none;\n}\n\n\nul.cent-pills {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    font-size: .8em;\n    display: flex;\n}\n\nul.cent-pills li {\n  background: rgb(224,224,224) none repeat scroll 0 0;\n  border: none;\n  border-radius: 24px;\n  color: rgb(86, 86, 86);\n  display: inline-block;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 18px;\n  margin: 0 24px 0 0;\n  padding: 4px 12px;\n  text-align: left;\n  text-decoration: none;\n}\n\nul.cent-pills li span {\n  display: block;\n  padding: 5px 0;\n  height: 18px;\n  float: left;\n  line-height: 24px;\n  font-size: 16px;\n}\n\nul.cent-pills li button {\n  margin: 4px 0 4px 16px !important;\n}\n\nul.cent-pills li a:link,\nul.cent-pills li a:active,\nul.cent-pills li a:visited {\n    color: #696969;\n    text-decoration: none;\n}\nul.cent-pills li a:hover {\n    color: #696969;\n    text-decoration: none;\n}\n\n.profile div {\n    line-height: 24px;\n}\n\n.profile span {\n     display: inline-block;\n     margin-right: 10px;\n}\n\n.profile span.roles {\n    float: left;\n}\n\n\n.toolbar svg {\n    fill: #FFF !important;\n}\n\n.ct-label {\n  fill: rgba(0, 0, 0, 0.4);\n  color: rgba(0, 0, 0, 0.4);\n  font-size: 0.75rem;\n  line-height: 1; }\n\n.ct-chart-line .ct-label, .ct-chart-bar .ct-label {\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex; }\n\n.ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start; }\n\n.ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start; }\n\n.ct-label.ct-vertical.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  text-align: right;\n  text-anchor: end; }\n\n.ct-label.ct-vertical.ct-end {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start; }\n\n.ct-chart-bar .ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  text-anchor: start; }\n\n.ct-chart-bar .ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  text-anchor: start; }\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {\n  -webkit-box-align: flex-end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: flex-end;\n  align-items: flex-end;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start; }\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {\n  -webkit-box-align: flex-start;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: flex-start;\n  align-items: flex-start;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: start; }\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: flex-end;\n  -webkit-justify-content: flex-end;\n  -ms-flex-pack: flex-end;\n  justify-content: flex-end;\n  text-align: right;\n  text-anchor: end; }\n\n.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: flex-start;\n  -webkit-justify-content: flex-start;\n  -ms-flex-pack: flex-start;\n  justify-content: flex-start;\n  text-align: left;\n  text-anchor: end; }\n\n.ct-grid {\n  stroke: rgba(0, 0, 0, 0.2);\n  stroke-width: 1px;\n  stroke-dasharray: 2px; }\n\n.ct-point {\n  stroke-width: 10px;\n  stroke-linecap: round; }\n\n.ct-line {\n  fill: none;\n  stroke-width: 4px; }\n\n.ct-area {\n  stroke: none;\n  fill-opacity: 0.1; }\n\n.ct-bar {\n  fill: none;\n  stroke-width: 10px;\n}\n.ct-slice-donut {\n  fill: none;\n  stroke-width: 60px;\n}\n.ct-series-a .ct-point,\n.ct-series-a .ct-line,\n.ct-series-a .ct-bar,\n.ct-series-a .ct-slice-donut {\n  stroke: #d70206;\n}\n.ct-series-a .ct-slice-pie,\n.ct-series-a .ct-area {\n  fill: #d70206;\n}\n.ct-series-b .ct-point,\n.ct-series-b .ct-line,\n.ct-series-b .ct-bar,\n.ct-series-b .ct-slice-donut {\n  stroke: #f05b4f; }\n.ct-series-b .ct-slice-pie,\n.ct-series-b .ct-area {\n  fill: #f05b4f;\n}\n.ct-series-c .ct-point,\n.ct-series-c .ct-line,\n.ct-series-c .ct-bar,\n.ct-series-c .ct-slice-donut {\n  stroke: #f4c63d;\n}\n.ct-series-c .ct-slice-pie,\n.ct-series-c .ct-area {\n  fill: #f4c63d;\n}\n.ct-series-d .ct-point,\n.ct-series-d .ct-line,\n.ct-series-d .ct-bar,\n.ct-series-d .ct-slice-donut {\n  stroke: #d17905;\n}\n.ct-series-d .ct-slice-pie,\n.ct-series-d .ct-area {\n  fill: #d17905;\n}\n.ct-series-e .ct-point,\n.ct-series-e .ct-line,\n.ct-series-e .ct-bar,\n.ct-series-e .ct-slice-donut {\n  stroke: #453d3f;\n}\n.ct-series-e .ct-slice-pie,\n.ct-series-e .ct-area {\n  fill: #453d3f;\n}\n.ct-series-f .ct-point,\n.ct-series-f .ct-line,\n.ct-series-f .ct-bar,\n.ct-series-f .ct-slice-donut {\n  stroke: #59922b;\n}\n.ct-series-f .ct-slice-pie,\n.ct-series-f .ct-area {\n  fill: #59922b;\n}\n.ct-series-g .ct-point,\n.ct-series-g .ct-line,\n.ct-series-g .ct-bar,\n.ct-series-g .ct-slice-donut {\n  stroke: #0544d3;\n}\n.ct-series-g .ct-slice-pie,\n.ct-series-g .ct-area {\n  fill: #0544d3;\n}\n.ct-series-h .ct-point,\n.ct-series-h .ct-line,\n.ct-series-h .ct-bar,\n.ct-series-h .ct-slice-donut {\n  stroke: #6b0392;\n}\n.ct-series-h .ct-slice-pie,\n.ct-series-h .ct-area {\n  fill: #6b0392;\n}\n.ct-series-i .ct-point,\n.ct-series-i .ct-line,\n.ct-series-i .ct-bar,\n.ct-series-i .ct-slice-donut {\n  stroke: #f05b4f;\n}\n.ct-series-i .ct-slice-pie,\n.ct-series-i .ct-area {\n  fill: #f05b4f;\n}\n.ct-series-j .ct-point,\n.ct-series-j .ct-line,\n.ct-series-j .ct-bar,\n.ct-series-j .ct-slice-donut {\n  stroke: #dda458;\n}\n.ct-series-j .ct-slice-pie,\n.ct-series-j .ct-area {\n  fill: #dda458;\n}\n.ct-series-k .ct-point,\n.ct-series-k .ct-line,\n.ct-series-k .ct-bar,\n.ct-series-k .ct-slice-donut {\n  stroke: #eacf7d;\n}\n.ct-series-k .ct-slice-pie,\n.ct-series-k .ct-area {\n  fill: #eacf7d;\n}\n.ct-series-l .ct-point,\n.ct-series-l .ct-line,\n.ct-series-l .ct-bar,\n.ct-series-l .ct-slice-donut {\n  stroke: #86797d;\n}\n.ct-series-l .ct-slice-pie,\n.ct-series-l .ct-area {\n  fill: #86797d;\n}\n.ct-series-m .ct-point,\n.ct-series-m .ct-line,\n.ct-series-m .ct-bar,\n.ct-series-m .ct-slice-donut {\n  stroke: #b2c326;\n}\n.ct-series-m .ct-slice-pie,\n.ct-series-m .ct-area {\n  fill: #b2c326;\n}\n.ct-series-n .ct-point,\n.ct-series-n .ct-line,\n.ct-series-n .ct-bar,\n.ct-series-n .ct-slice-donut {\n  stroke: #6188e2;\n}\n.ct-series-n .ct-slice-pie,\n.ct-series-n .ct-area {\n  fill: #6188e2;\n}\n.ct-series-o .ct-point,\n.ct-series-o .ct-line,\n.ct-series-o .ct-bar,\n.ct-series-o .ct-slice-donut {\n  stroke: #a748ca;\n}\n.ct-series-o .ct-slice-pie,\n.ct-series-o .ct-area {\n  fill: #a748ca;\n}\n.ct-square {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-square:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 100%;\n}\n.ct-square:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-square > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-minor-second {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-second:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 93.75%;\n}\n.ct-minor-second:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-minor-second > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-major-second {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-second:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 88.8888888889%;\n}\n.ct-major-second:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-major-second > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-minor-third {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-third:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 83.3333333333%;\n}\n.ct-minor-third:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-minor-third > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-major-third {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-third:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 80%;\n}\n.ct-major-third:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-major-third > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-perfect-fourth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-perfect-fourth:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 75%;\n}\n.ct-perfect-fourth:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-perfect-fourth > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-perfect-fifth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-perfect-fifth:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 66.6666666667%;\n}\n.ct-perfect-fifth:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-perfect-fifth > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-minor-sixth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-minor-sixth:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 62.5%;\n}\n.ct-minor-sixth:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-minor-sixth > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-golden-section {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-golden-section:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 61.804697157%;\n}\n.ct-golden-section:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-golden-section > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-major-sixth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-sixth:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 60%;\n}\n.ct-major-sixth:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-major-sixth > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-minor-seventh {\n  display: block;\n  position: relative;\n  width: 100%; }\n.ct-minor-seventh:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 56.25%;\n}\n.ct-minor-seventh:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.CodeMirror{\n  font-family:monospace;\n  height:300px;\n  color:#000\n}\n.CodeMirror-lines{padding:4px 0}\n.CodeMirror pre{padding:0 4px}\n.CodeMirror-gutter-filler,\n.CodeMirror-scrollbar-filler{background-color:#fff}\n.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}\n.CodeMirror-linenumber{\n  padding:0 3px 0 5px;\n  min-width:20px;\n  text-align:right;color:#999;\n  -moz-box-sizing:content-box;\n  box-sizing:content-box\n}\n.CodeMirror-guttermarker{color:#000}\n.CodeMirror-guttermarker-subtle{color:#999}\n.CodeMirror div.CodeMirror-cursor{border-left:1px solid #000}\n.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}\n.CodeMirror.cm-fat-cursor div.CodeMirror-cursor{width:auto;border:0;background:#7e7}\n.CodeMirror.cm-fat-cursor div.CodeMirror-cursors{z-index:1}\n.cm-animate-fat-cursor{\n  width:auto;border:0;\n  -webkit-animation:blink 1.06s steps(1) infinite;\n  -moz-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite}@-moz-keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}@-webkit-keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}@keyframes blink{0%{background:#7e7}50%{background:0 0}100%{background:#7e7}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-ruler{border-left:1px solid #ccc;position:absolute}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}\n  .cm-s-default .cm-number{color:#164}\n  .cm-s-default .cm-def{color:#00f}\n  .cm-s-default .cm-variable-2{color:#05a}\n  .cm-s-default .cm-variable-3{color:#085}\n  .cm-s-default .cm-comment{color:#a50}\n  .cm-s-default .cm-string{color:#a11}\n  .cm-s-default .cm-string-2{color:#f50}\n  .cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}\n  .cm-s-default .cm-builtin{color:#30a}\n  .cm-s-default .cm-bracket{color:#997}\n  .cm-s-default .cm-tag{color:#170}\n  .cm-s-default .cm-attribute{color:#00c}\n  .cm-s-default .cm-header{color:#00f}\n  .cm-s-default .cm-quote{color:#090}\n  .cm-s-default .cm-hr{color:#999}\n  .cm-s-default .cm-link{color:#00c}\n  .cm-negative{color:#d44}\n  .cm-positive{color:#292}\n  .cm-header,.cm-strong{font-weight:700}\n  .cm-em{font-style:italic}\n  .cm-link{text-decoration:underline}\n  .cm-strikethrough{text-decoration:line-through}\n  .cm-invalidchar,.cm-s-default .cm-error{color:red}\n  div.CodeMirror span.CodeMirror-matchingbracket{color:#0f0}\n  div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#f22}\n  .CodeMirror-matchingtag{background:rgba(255,150,0,.3)}\n  .CodeMirror-activeline-background{background:#e8f2ff}\n  .CodeMirror{position:relative;overflow:hidden;background:#fff}\n  .CodeMirror-scroll{overflow:scroll!important;margin-bottom:-30px;margin-right:-30px;padding-bottom:30px;height:100%;outline:0;position:relative;-moz-box-sizing:content-box;box-sizing:content-box}\n  .CodeMirror-sizer{position:relative;border-right:30px solid transparent;-moz-box-sizing:content-box;box-sizing:content-box}\n  .CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none}\n  .CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}\n  .CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}\n  .CodeMirror-scrollbar-filler{right:0;bottom:0}\n  .CodeMirror-gutter-filler{left:0;bottom:0}\n  .CodeMirror-gutters{position:absolute;left:0;top:0;z-index:3}\n  .CodeMirror-gutter{white-space:normal;height:100%;-moz-box-sizing:content-box;box-sizing:content-box;display:inline-block;margin-bottom:-30px}\n  .CodeMirror-gutter-wrapper{position:absolute;z-index:4;height:100%}\n  .CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}\n  .CodeMirror-gutter-wrapper{-webkit-user-select:none;-moz-user-select:none;user-select:none}\n  .CodeMirror-lines{cursor:text;min-height:1px}\n  .CodeMirror pre{-moz-border-radius:0;-webkit-border-radius:0;border-radius:0;border-width:0;background:0 0;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent}\n  .CodeMirror-wrap pre{word-wrap:break-word;white-space:pre-wrap;word-break:normal}\n  .CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}\n  .CodeMirror-linewidget{position:relative;z-index:2;overflow:auto}\n  .CodeMirror-code{outline:0}\n  .CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}\n  .CodeMirror-measure pre{position:static}\n  .CodeMirror div.CodeMirror-cursor{position:absolute;border-right:none;width:0}\n  div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}\n  .CodeMirror-focused div.CodeMirror-cursors{visibility:visible}\n  .CodeMirror-selected{background:#d9d9d9}\n  .CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}\n  .CodeMirror-crosshair{cursor:crosshair}\n  .CodeMirror ::selection{background:#d7d4f0}\n  .CodeMirror ::-moz-selection{background:#d7d4f0}\n  .cm-searching{background:#ffa;background:rgba(255,255,0,.4)}\n  .cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}\n  .cm-tab-wrap-hack:after{content:''}\n  span.CodeMirror-selectedtext{background:0 0}\n.ct-minor-seventh > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-major-seventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-seventh:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 53.3333333333%;\n}\n.ct-major-seventh:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-major-seventh > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-octave {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-octave:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 50%;\n}\n.ct-octave:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-octave > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n.ct-major-tenth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-tenth:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 40%;\n  }\n.ct-major-tenth:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n.ct-major-tenth > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n.ct-major-eleventh {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-eleventh:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 37.5%;\n}\n.ct-major-eleventh:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-major-eleventh > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-major-twelfth {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-major-twelfth:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 33.3333333333%;\n}\n.ct-major-twelfth:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-major-twelfth > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n.ct-double-octave {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n.ct-double-octave:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: 25%;\n}\n.ct-double-octave:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.ct-double-octave > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.cent-card-calendar {\n  height: 600px;\n}\n\n\n/* react-big-calendar custom */\n.rbc-toolbar-label {\n  font-size: 1rem;\n  color: rgb(117, 117, 117);\n}\n.rbc-toolbar button {\n  text-transform: uppercase;\n  font-size: .8rem;\n  color: rgb(117, 117, 117);\n  display: inline-block;\n  margin: 0 8px 0 0;\n  text-align: center;\n  vertical-align: middle;\n  background: none;\n  background-image: none;\n  border: none;\n  padding: .375rem 1rem;\n  border-radius: 4px;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-btn-group>button:first-child {\n  border-radius: 0;\n}\n.rbc-btn-group>button:last-child {\n  border-radius: 0;\n  margin: 0;\n}\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n  background-image: none;\n  box-shadow: none;\n  background-color: #e6e6e6;\n  border: none;\n}\n.rbc-toolbar button:active:hover,\n.rbc-toolbar button.rbc-active:hover,\n.rbc-toolbar button:active:focus,\n.rbc-toolbar button.rbc-active:focus {\n  color: rgb(117, 117, 117);\n  background-color: #e6e6e6;\n  border: none;\n}\n.rbc-header {\n  padding: 2px 4px;\n  font-size: 1rem;\n  min-height: 14px;\n}\n.rbc-off-range {\n  color: #b3b3b3;\n  background-color: #F5F5F5;\n  border-left: 1px solid #DDD;\n}\n.rbc-off-range-bg {\n  background-color: #F5F5F5;\n}\n.rbc-off-range:first-child {\n  border-left: 0px;\n}\n.rbc-date-cell.rbc-now a {\n  color: rgb(35, 151, 190);\n}\n.rbc-current-time-indicator {\n  background-color: rgb(89, 186, 80)!important;\n}\n.rbc-row-segment {\n  padding: 1px 1px 0 1px;\n}\n.rbc-event {\n  padding: 4px;\n  color: rgb(117, 117, 117);\n  background-color: #AEE9FB;\n  border-radius: 2px;\n  margin: 0 1px 1px 2px;\n}\n.rbc-show-more {\n  background-color: rgba(255,255,255,0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n  padding: 8px;\n}\n.rbc-overlay {\n  padding: 16px;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.12);\n  border-radius: 2px;\n  border: none;\n}\n.rbc-day-slot .rbc-event {\n  border: none!important;\n  margin-right: 8px!important;\n}\n.rbc-day-slot .rbc-event-label {\n  padding: 8px;\n}\n.rbc-day-slot .rbc-event-content {\n  padding: 8px;\n}\n.rbc-event-overlaps {\n}\n.rbc-overlay-header {\n  border-bottom: none;\n  margin: 0 0 16px 0;\n  padding: 0;\n}\n.rbc-time-slot {\n  min-height: 40px;\n}\n\n\n/* formatting for overlapped events */\n.rbc-events-container {\n  display: grid;\n  grid-template-rows: repeat(96, 20.25px);\n}\n.rbc-day-slot .rbc-event {\n  position: static;\n}\n.rbc-day-slot .rbc-event--global {\n  background-color: #fbab18;\n}\n.rbc-day-slot .rbc-event--regional {\n  background-color: #6ebe4a;\n}\n/* react-big-calendar custom end */\n\n/*  react-calendar-timeline custom */\n.rct-item {\n  background: rgba(35, 151, 190, 1)!important;\n  border-color: rgba(35, 151, 190, 1)!important;\n  border-radius: 5px;\n}\n.rct-sidebar-header {\n  background: rgba(255, 255, 255, 1)!important;\n}\n.rct-sidebar-row {\npadding: 0 8px!important;\n}\n.rct-label-group {\n  background: rgba(255, 255, 255, 1)!important;\n  color: rgba(117, 117, 117, 1)!important;\n  border-left: 2px solid rgba(117, 117, 117, .5)!important;\n  border-bottom: 1px solid rgba(255, 255, 255, 1)!important;\n}\n.rct-label {\n  background: rgba(35, 151, 190, 1)!important;\n  color: rgba(255, 255, 255, 1)!important;\n  border-left: 2px solid rgba(255, 255, 255, 1)!important;\n  border-bottom: 1px solid rgba(255, 255, 255, 1)!important;\n}\n.react-calendar-timeline .rct-today {\n  background-color: rgb(89, 186, 80)!important;\n}\n\n/*  react-calendar-timeline custom end  */\n\n\n  /* styles full and light colours */\n.style_a {color: #fff; background: #EF5350;}  /* red 400 */\n.style_a_ {color: #fff; background: #EF9A9A;} /* red 200 */\n.style_b {color: #fff; background: #F57F17;}  /* yellow 900 */\n.style_b_ {color: #fff; background: #FBC02D;} /* yellow 700 */\n.style_c {color: #fff; background: #01579B;}  /* light blue 900 */\n.style_c_ {color: #fff; background: #0288D1;} /* light blue 700 */\n.style_d {color: #fff; background: #5E35B1;}  /* deep purple 600 */\n.style_d_ {color: #fff; background: #7E57C2;} /* deep purple 400 */\n.style_e {color: #fff; background: #FBC02D;}\n.style_e_ {color: #fff; background: #FBC02D;}\n.style_f {color: #fff; background: #FBC02D;}\n.style_f_ {color: #fff; background: #FBC02D;}\n.style_g {color: #fff; background: #FBC02D;}\n.style_g_ {color: #fff; background: #FBC02D;}\n.style_h {color: #fff; background: #FBC02D;}\n.style_h_ {color: #fff; background: #FBC02D;}\n.style_i {color: #fff; background: #FBC02D;}\n.style_i_ {color: #fff; background: #FBC02D;}\n.style_j {color: #fff; background: #FBC02D;}\n.style_j_ {color: #fff; background: #FBC02D;}\n.style_k {color: #fff; background: #FBC02D;}\n.style_k_ {color: #fff; background: #FBC02D;}\n.style_l {color: #fff; background: #FBC02D;}\n.style_l_ {color: #fff; background: #FBC02D;}\n.style_m {color: #fff; background: #FBC02D;}\n.style_m_ {color: #fff; background: #FBC02D;}\n.style_n {color: #fff; background: #FBC02D;}\n.style_n_ {color: #fff; background: #FBC02D;}\n.style_o {color: #fff; background: #FBC02D;}\n.style_o_ {color: #fff; background: #FBC02D;}\n.style_p {color: #fff; background: #FBC02D;}\n.style_p_ {color: #fff; background: #FBC02D;}\n.style_q {color: #fff; background: #FBC02D;}\n.style_q_ {color: #fff; background: #FBC02D;}\n.style_r {color: #fff; background: #FBC02D;}\n.style_r_ {color: #fff; background: #FBC02D;}\n.style_s {color: #fff; background: #FBC02D;}\n.style_s_ {color: #fff; background: #FBC02D;}\n.style_t {color: #fff; background: #FBC02D;}\n.style_t_ {color: #fff; background: #FBC02D;}\n.style_u {color: #fff; background: #FBC02D;}\n.style_u_ {color: #fff; background: #FBC02D;}\n.style_v {color: #fff; background: #FBC02D;}\n.style_v_ {color: #fff; background: #FBC02D;}\n.style_w {color: #fff; background: #FBC02D;}\n.style_w_ {color: #fff; background: #FBC02D;}\n.style_x {color: #fff; background: #FBC02D;}\n.style_x_ {color: #fff; background: #FBC02D;}\n.style_y {color: #fff; background: #FBC02D;}\n.style_y_ {color: #fff; background: #FBC02D;}\n.style_z {color: #fff; background: #FBC02D;}\n.style_z_ {color: #fff; background: #FBC02D;}\n.style_0 {color: #fff; background: #FBC02D;}\n.style_0_ {color: #fff; background: #FBC02D;}\n.style_1 {color: #fff; background: #FBC02D;}\n.style_1_ {color: #fff; background: #FBC02D;}\n.style_2 {color: #fff; background: #FBC02D;}\n.style_2_ {color: #fff; background: #FBC02D;}\n.style_3 {color: #fff; background: #FBC02D;}\n.style_3_ {color: #fff; background: #FBC02D;}\n.style_4 {color: #fff; background: #FBC02D;}\n.style_4_ {color: #fff; background: #FBC02D;}\n.style_5 {color: #fff; background: #FBC02D;}\n.style_5_ {color: #fff; background: #FBC02D;}\n.style_6 {color: #fff; background: #FBC02D;}\n.style_6_ {color: #fff; background: #FBC02D;}\n.style_7 {color: #fff; background: #FBC02D;}\n.style_7_ {color: #fff; background: #FBC02D;}\n.style_8 {color: #fff; background: #FBC02D;}\n.style_8_ {color: #fff; background: #FBC02D;}\n.style_9 {color: #fff; background: #FBC02D;}\n.style_9_ {color: #fff; background: #FBC02D;}\n\nbutton[disabled].rbc-btn{cursor:not-allowed}\nbutton.rbc-input::-moz-focus-inner{border:0;padding:0}\n\n.speed-dial {\n  margin: 0;\n  top: auto;\n  right: 20px;\n  bottom: 20px;\n  left: auto;\n  position: fixed;\n  z-index: 2;\n}\n\n.speed-dial .cover {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 1100; /* just above title bar */\n  transition: opacity 0.2s ease-in-out;\n  opacity: 1;\n}\n\n.speed-dial .closed .cover {\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out, height 0s linear 0.2s;\n}\n\n.speed-dial .actions {\n  position: absolute;\n}\n\n.speed-dial.closed .actions {\n  transition: top 0s linear 0.2s;\n}\n\n.speed-dial .container {\n  position: fixed;\n  bottom: 80px;\n  right: 20px;\n  width: 56px;\n  text-align: center;\n  z-index: 1110;\n}\n\n.speed-dial .button {\n  transition: transform 0.2s ease-in-out;\n}\n\n.speed-dial.closed .button {\n  transform: scale(0, 0);\n}\n\n.speed-dial .action {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.speed-dial .tooltip {\n  position: absolute;\n  right: 75px;\n  top: 0.5em;\n  color: black;\n  background: lightgrey;\n  padding: 0.5em;\n  border-radius: 0.5em;\n  white-space: nowrap;\n  opacity: 1;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.speed-dial.closed .tooltip {\n  opacity: 0;\n}\n\n.speed-dial.opened .main svg {\n  transform: rotate(135deg);\n}\n\n.cent-ul-text {\n  margin: 8px 32px;\n  list-style-type: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
